{
  "common": {
    "appTitle": "Draughts MVP",
    "back": "Retour",
    "exit": "Quitter",
    "cancel": "Annuler",
    "close": "Fermer",
    "continue": "Continuer",
    "copy": "Copier",
    "error": "Erreur",
    "loading": "Chargement...",
    "retry": "Réessayer",
    "or": "ou",
    "vs": "vs",
    "you": "Vous",
    "anonymous": "Anonyme",
    "send": "Envoyer",
    "download": "Télécharger",
    "noLimit": "Sans limite",
    "comingSoon": "Bientôt",
    "version": "v{{version}}",
    "enabled": "Activé",
    "disabled": "Désactivé",
    "apply": "Appliquer",
    "errorBoundary": "Quelque chose s’est mal passé. Essayez de recharger : si une nouvelle version vient de sortir, le rechargement la prendra.",
    "dismissNotice": "Fermer"
  },
  "errors": {
    "loadFailed": "Impossible de charger ces données. Réessaie.",
    "network": "Pas de connexion internet. Vérifie ton réseau et réessaie.",
    "notFound": "Cette page n'existe pas (ou plus)."
  },
  "senzaRete": {
    "titolo": "Vous êtes hors ligne",
    "dati": "Cette page ne peut pas charger ses données tant que la connexion n'est pas revenue.",
    "home": "Les parties en ligne, les tournois et le classement ne sont pas disponibles. Vous pouvez tout de même jouer contre l'ordinateur ou en face à face sur cet appareil."
  },
  "avvisoServizio": {
    "etichetta": "Avis de service",
    "preset": {
      "riavvio": "Redémarrage programmé : le serveur sera injoignable quelques instants. Les parties en cours ne sont pas perdues.",
      "riavvioAlle": "Redémarrage programmé à {{ora}} : le serveur sera injoignable quelques instants. Les parties en cours ne sont pas perdues.",
      "manutenzione": "Maintenance en cours : certaines fonctions peuvent être indisponibles.",
      "manutenzioneAlle": "Maintenance à partir de {{ora}} : certaines fonctions peuvent être indisponibles.",
      "rallentamenti": "Le serveur est plus lent que d'habitude. Nous y travaillons."
    }
  },
  "nav": {
    "play": "Jouer",
    "tournaments": "Tournois",
    "leaderboard": "Classement",
    "myGames": "Mes Parties",
    "logout": "Déconnexion",
    "signIn": "Connexion",
    "backToLocal": "Retour au Jeu Local",
    "backToTournaments": "Retour aux Tournois",
    "backToGames": "Retour aux Parties",
    "home": "Home",
    "arena": "Arène",
    "profile": "Profil",
    "loginRequired": "Connexion requise",
    "faq": "FAQ & Contact",
    "rules": "Règles",
    "editor": "Éditeur",
    "strumenti": "Tools"
  },
  "gara": {
    "torneoInCorso": "Tournoi en cours",
    "arenaInCorso": "Arène en cours"
  },
  "strumenti": {
    "titoloFoglio": "Tools (Outils)",
    "orologio": "Pendule",
    "estraiApertura": "Tirer une ouverture"
  },
  "orologio": {
    "titolo": "Pendule de table",
    "sottotitolo": "Posez le téléphone entre les deux joueurs : après avoir joué, touchez votre moitié",
    "tocca": "Touchez pour commencer",
    "pausa": "Pause",
    "riprendi": "Reprendre",
    "azzera": "Réinitialiser",
    "impostazioni": "Réglages",
    "suoni": "Sons",
    "suonoTocco": "Son du toucher",
    "suonoPocoTempo": "Son de temps bas",
    "tempo": "Temps",
    "stessoTempo": "Même temps pour les deux",
    "scaduto": "Temps écoulé",
    "mosse": "Coups"
  },
  "apertura": {
    "sottotitolo": "Tirez une ouverture officielle",
    "andataRitorno": "Cette ouverture peut favoriser une couleur : en compétition, elle se joue aller-retour, les couleurs inversées.",
    "estrai": "Tirer",
    "estraiDiNuovo": "Tirer à nouveau",
    "vediTabelle": "Voir les tables complètes",
    "posizioneIniziale": "Position de départ"
  },
  "editor": {
    "title": "Éditeur",
    "subtitle": "Composez une position pour étudier, analyser ou jouer",
    "boardLabel": "Damier modifiable",
    "sideToMove": "Trait aux",
    "reset": "Rétablir",
    "clear": "Vider",
    "flip": "Pivoter",
    "playPosition": "Jouer la position",
    "playAI": "Jouer contre l'ordinateur",
    "challenge": "Défier un ami",
    "challengeNote": "La partie démarre depuis votre position et est toujours amicale (non classée).",
    "tools": {
      "label": "Pièces",
      "whiteMan": "Pion blanc",
      "whiteKing": "Dame blanche",
      "blackMan": "Pion noir",
      "blackKing": "Dame noire",
      "erase": "Effacer",
      "cycle": "Changer la pièce"
    },
    "library": {
      "open": "Positions enregistrées",
      "title": "Positions enregistrées",
      "nameLabel": "Nom",
      "namePlaceholder": "Nom de la position",
      "defaultName": "Position",
      "defaultNameAnalysis": "Analyse",
      "save": "Enregistrer",
      "overwrite": "Remplacer",
      "willOverwrite": "« {{name}} » sera remplacée.",
      "saved": "Dans votre bibliothèque",
      "empty": "Aucune position enregistrée. Composez une position et enregistrez-la ici.",
      "load": "Charger {{name}}",
      "lineBadge_one": "{{count}} coup",
      "lineBadge_other": "{{count}} coups",
      "askLoad": "Charger « {{name}} » ? La position sur le plateau sera remplacée.",
      "askLoadLine": "Charger « {{name}} » ? La position et la ligne en cours seront remplacées.",
      "confirmLoad": "Charger",
      "rename": "Renommer {{name}}",
      "share": "Partager {{name}}",
      "shareCopied": "Lien copié",
      "shareTitle": "Position de dames",
      "shareText": "Regarde cette position de dames",
      "delete": "Supprimer {{name}}",
      "askDelete": "Supprimer « {{name}} » ?",
      "confirmDelete": "Supprimer",
      "errors": {
        "nameTaken": "Une position porte déjà ce nom.",
        "full": "Bibliothèque pleine : supprimez une position pour en enregistrer une autre.",
        "saveFailed": "Échec de l'enregistrement. Réessayez.",
        "deleteFailed": "Échec de la suppression. Réessayez.",
        "loadFailed": "Cette position est illisible.",
        "loadListFailed": "Impossible de charger la bibliothèque.",
        "shareFailed": "Impossible de copier le lien."
      }
    },
    "fen": {
      "label": "Position (FEN)",
      "copy": "Copier FEN",
      "copied": "Copié",
      "invalid": "FEN invalide."
    },
    "analysis": {
      "title": "Analyse",
      "hint": "Jouez les deux couleurs. Reculez et jouez un autre coup pour changer de ligne.",
      "save": "Enregistrer l'analyse",
      "run": "Analyser",
      "depth": "Profondeur",
      "fast": "Rapide",
      "standard": "Standard",
      "deep": "Profonde",
      "evaluation": "Évaluation",
      "cancel": "Annuler",
      "reached": "Profondeur atteinte"
    },
    "invalid": {
      "noWhite": "Ajoutez au moins une pièce blanche.",
      "noBlack": "Ajoutez au moins une pièce noire.",
      "manOnPromotionRow": "Un pion ne peut pas rester sur sa rangée de promotion — transformez-le en dame ou déplacez-le.",
      "tooManyPieces": "Trop de pièces pour cette variante.",
      "sideToMoveNoMoves": "Le camp au trait n'a aucun coup légal.",
      "alreadyTerminal": "Cette position est déjà décidée (gagnée ou nulle).",
      "offBoard": "Une pièce se trouve sur une case que cette variante ne possède pas.",
      "duplicateSquare": "Deux pièces sur la même case."
    }
  },
  "rules": {
    "channels": {
      "cta": "Chaînes recommandées",
      "title": "Chaînes recommandées",
      "note": "Des chaînes que nous recommandons pour regarder et étudier cette variante.",
      "opensOnYouTube": "S’ouvre sur YouTube"
    },
    "backToRules": "Toutes les règles",
    "playOnline": "Jouer maintenant",
    "playAI": "Jouer contre l'ordinateur",
    "indexTitle": "Règles des dames",
    "indexIntro": "Deux règlements au même endroit : les règles du jeu de chaque variante prise en charge, et les règles qui régissent nos tournois en ligne.",
    "gameTitle": "Règles des dames par variante",
    "gameIntro": "Les dames — aussi appelées draughts, checkers, dama et dammen — se jouent partout dans le monde, chaque région avec ses propres règles. Parcourez ci-dessous les règles de chaque variante prise en charge.",
    "gameCtaDesc": "Plateau, déplacements, prises et promotion — variante par variante.",
    "heroSubtitle": "Règles, disposition initiale et comment jouer aux {{variant}}.",
    "startingPosition": "Position de départ",
    "howToPlay": "Comment jouer",
    "otherVariants": "Autres variantes",
    "eyebrow": "Règles",
    "glance": {
      "title": "En un coup d'œil",
      "board": "Damier",
      "pieces": "Pièces par camp",
      "starts": "Commence"
    },
    "theme": {
      "movement": "Déplacement",
      "capture": "Prises",
      "promotion": "Promotion"
    },
    "variantsLabel": "Variantes",
    "draughtsWord": "dames",
    "tournaments": {
      "title": "Règles des tournois",
      "heroSubtitle": "Tout ce qu'un tournoi décide tout seul, du nombre de rondes aux départages.",
      "intro": "Une fois lancé, un tournoi avance tout seul : il compte les inscrits présents, choisit le système d'appariement, fixe le nombre de rondes et établit le classement. Voici les règles qu'il applique, dans l'ordre où il les applique.",
      "source": "Source : FIDE C.04.1 et FMJD Annex 3, adaptés au jeu en ligne.",
      "cta": "Comment se déroule un tournoi",
      "ctaDesc": "Format, rondes, inscription, absences, départages et l'arène.",
      "chaptersLabel": "Chapitres",
      "format": {
        "title": "Format",
        "body": [
          "Un seul format à rondes, le toutes rondes/suisse : celui qui ouvre un tournoi ne choisit pas entre le toutes rondes et le système suisse, il choisit un seuil d'inscrits. À côté des tournois il y a l'arène, qui est autre chose : voir le chapitre « L'arène ».",
          "À l'heure du départ, on compte les inscrits réellement présents. En dessous du seuil, on joue un toutes rondes : chacun rencontre tout le monde, selon les tables de Berger. À partir du seuil, on joue au système suisse : à chaque ronde on est apparié avec des joueurs au même score, et on n'affronte jamais deux fois le même adversaire.",
          "Le seuil par défaut est 7 et se règle entre 7 et 20 ; un toutes rondes accepte au plus 19 inscrits.",
          "La raison est simple : à l'ouverture d'un tournoi, personne ne sait combien viendront, et choisir le format d'avance revient à le choisir à l'aveugle.",
          "Victoire 2 points, nulle 1 point, défaite zéro. Si les inscrits sont en nombre impair, un joueur est exempt à chaque ronde, et ce que vaut cette exemption dépend du format : au système suisse elle vaut 2 points comme une victoire — 4 dans un tournoi aller-retour, où chaque ronde compte deux parties — alors qu'en toutes rondes elle ne rapporte aucun point, car là chacun rencontre tous les autres et l'exemption n'est qu'une ronde qui ne se joue pas. Dans les deux cas elle ne compte pas comme une partie gagnée et n'entre pas dans les départages."
        ]
      },
      "rounds": {
        "title": "Nombre de rondes",
        "body": [
          "Le nombre est fixé au départ du tournoi, d'après les inscrits présents. Avec le seuil par défaut, par nombre d'inscrits :",
          "Un tournoi accepte au plus 200 inscrits : dix rondes sont donc le maximum — onze avec la ronde supplémentaire.",
          "En toutes rondes, il y a autant de rondes qu'il en faut pour que chacun rencontre tous les autres. À trois ou quatre inscrits, l'aller-retour se joue toujours, quel que soit le choix de l'organisateur : chaque ronde compte alors deux parties, car avec une seule partie par adversaire une défaite à la première ronde déciderait déjà du tournoi. À quatre, ce sont trois rondes et six parties par personne ; à trois, on joue les mêmes trois rondes mais quelqu'un se repose chaque fois, donc chacun se repose une fois et joue quatre parties — et la ronde de repos ne rapporte aucun point.",
          "Au système suisse, doubler le plateau ajoute une ronde : chaque ronde divise par deux le nombre de joueurs qui peuvent encore finir avec le maximum. C'est une ronde de plus qu'il n'en faudrait à un tournoi à élimination, sans quoi deux joueurs pourraient finir à égalité en tête sans s'être jamais rencontrés.",
          "Deux interrupteurs changent le compte. « Ronde supplémentaire » en ajoute une à la table quand le plateau la supporte, et ne vaut que si le départ donne un suisse : en toutes rondes chacun rencontre déjà tout le monde, et une ronde de plus ne serait qu'une revanche pour tous. « Aller-retour », lui, n'ajoute pas de rondes, il les remplit : chaque appariement se joue deux fois de suite, couleurs inversées et sur la même ouverture, à l'intérieur de la même ronde, qui dure donc deux fois plus longtemps. Cela marche pareil en toutes rondes et en suisse, et les points restent par partie : une victoire et une nulle font 3, deux victoires 4."
        ],
        "rounds": [
          "3-4 — toutes rondes, 3 rondes",
          "5-6 — toutes rondes, 5 rondes",
          "7-8 — suisse, 4 rondes",
          "9-16 — suisse, 5 rondes",
          "17-32 — suisse, 6 rondes",
          "33-64 — suisse, 7 rondes",
          "65-128 — suisse, 8 rondes",
          "129-192 — suisse, 9 rondes",
          "193-200 — suisse, 10 rondes"
        ]
      },
      "entry": {
        "title": "Inscription et retrait",
        "body": [
          "Ouvrir un tournoi est ouvert à quiconque a un compte enregistré : aucune autorisation n'est nécessaire et il n'y a pas d'organisateur officiel. Les invités et les ordinateurs n'entrent pas dans les tournois, ni pour les ouvrir ni pour les jouer.",
          "Trois compétitions en cours par personne : vous pouvez garder jusqu'à trois tournois ou arènes ouverts en même temps ; pour en ouvrir un autre, attendez que l'un se termine, ou annulez-le.",
          "Un tournoi se programme, il ne se lance pas à la main : le début se fixe entre cinq minutes et quatorze jours à l'avance. Celui qui l'ouvre ne fait que l'organiser : pour y jouer, il doit appuyer sur « S'inscrire » sur la page du tournoi comme tout le monde, et tant qu'il ne le fait pas il ne compte pas dans l'effectif — un minimum de 3 demande trois personnes en plus de lui.",
          "Les places vont de 3 à 200. Le minimum pour partir est 3, et l'organisateur peut le relever : si à l'heure du départ les inscrits sont moins nombreux que le minimum, le tournoi s'annule tout seul. Tant qu'il n'a pas commencé, l'organisateur peut l'annuler ; après, non, car ceux qui jouent ont le droit de finir.",
          "Un tournoi peut être privé : on n'y entre qu'avec le mot de passe choisi par l'organisateur, ou avec le lien d'invitation.",
          "On s'inscrit jusqu'au début de la première ronde, et jusque-là on peut aussi se retirer — annuler avant le départ fait disparaître aussitôt de la grille, puisque rien n'a encore été joué. Ensuite la porte se ferme dans les deux sens : qui est dedans reste au tableau, car se retirer à mi-parcours laisserait un adversaire sans partie à chaque ronde restante."
        ]
      },
      "absences": {
        "title": "Absences",
        "body": [
          "Cela dépend d'où vous étiez, et les trois cas se terminent de trois façons différentes.",
          "Si vous êtes simplement déconnecté, la partie s'ouvre quand même et votre pendule tourne. Arriver avec trois minutes de retard, c'est jouer avec trois minutes de moins, pas perdre la partie : ce n'est que si vous n'arrivez jamais que vous perdez au temps. Une partie à laquelle l'un des deux ne s'est jamais assis ne bouge le classement de personne.",
          "Il en va de même si vous vous connectez et que la connexion tombe avant votre premier coup : c'est votre pendule qui décide. Après votre premier coup, si vous tombez, vous avez 30 secondes pour revenir, comme dans toute partie.",
          "Si en revanche vous êtes déjà pris dans une autre partie — une arène, un défi, un autre tournoi —, la partie de la ronde ne s'ouvre pas du tout et vous prenez une défaite par forfait, les 2 points allant à votre adversaire. Ce n'est pas une punition : vous ouvrir un second damier rendrait inaccessible celui où vous jouez déjà.",
          "Si vous manquez à deux, la ronde se clôt 0-0 et personne ne prend rien. Une nulle de bureau récompenserait l'absence.",
          "Dans aucun des trois cas on n'est exclu : à la ronde suivante on est apparié comme d'habitude.",
          "Une dernière chose vaut pour tous : un tournoi a une durée annoncée, et si des parties sont encore en cours à cette heure, elles disposent de dix minutes. Passé ce délai, le tournoi se ferme et les parties encore ouvertes sont déclarées nulles."
        ]
      },
      "openingMoves": {
        "title": "Coups d'ouverture",
        "body": [
          "Cela dépend de la façon dont le tournoi a été ouvert, et il y a neuf possibilités.",
          "« Coup libre » est la normale : on joue dès le premier coup, et rien n'est imposé.",
          "Viennent ensuite les tirages. Trois d'entre eux posent un, deux ou trois coups légaux au hasard, et valent sur toutes les variantes. Quatre autres tirent d'une table officielle F.I.D., et n'existent que sur l'italienne et l'anglaise, les deux variantes qui ont une table fédérale : ce qu'on y choisit, c'est à quel point l'ouverture qui sortira peut être déséquilibrée — jusqu'à 1N/1B, jusqu'à 2N/2B, jusqu'à 3N/3B, ou les 174. Au système suisse, la même ouverture ne sort jamais deux fois dans le même tournoi.",
          "Et puis il y a le tournoi à thème : celui qui ouvre choisit UNE des 174 ouvertures officielles, et tout le monde la joue, à toutes les rondes et dans toutes les parties. C'est le seul cas où l'ouverture est connue avant de commencer, et le seul où la règle « jamais deux fois la même » ne s'applique pas — ce serait exactement le contraire de ce qu'un tournoi à thème demande.",
          "En aller-retour, les deux parties d'une ronde se jouent sur la même ouverture, couleurs inversées : c'est ainsi qu'une ouverture déséquilibrée cesse d'avantager quelqu'un."
        ]
      },
      "rated": {
        "title": "Tournois classés",
        "body": [
          "Si le tournoi est classé, oui — et pas dans un classement à part : les parties de tournoi font bouger le même classement que toutes les autres, celui de la variante et de la cadence jouées. C'est celui qui ouvre le tournoi qui décide, et par défaut il est classé.",
          "Un tournoi ou une arène classés peuvent avoir un classement minimum, c'est-à-dire un seuil pour entrer, par paliers de 1000 à 2000 : il se mesure sur votre classement pour cette variante et cette cadence, non sur un classement général. Dans les compétitions amicales ce seuil n'existe pas, car le classement ne bouge pas et il n'y a rien à protéger. Il n'y a pas de plafond : personne n'est écarté parce qu'il est trop fort.",
          "Une chose peut ensuite éteindre le classement d'elle-même, et c'est l'ouverture. La règle fédérale dit qu'une seule partie suffit tant que l'ouverture va jusqu'à 2N/2B ; au-delà, l'avantage d'une couleur est trop grand pour qu'une partie sèche le compense, et l'aller-retour devient nécessaire. Cela vaut dans les deux cas : sur un tirage compte le plafond de la table dont on tire, sur un tournoi à thème compte la force de l'ouverture choisie, qui y est déjà connue. Si la combinaison ne tient pas, le tournoi naît amical au lieu d'être refusé — et activer l'aller-retour le rend à nouveau classé.",
          "Enfin, les parties auxquelles l'un des deux ne s'est jamais assis ne sont pas classées."
        ]
      },
      "tiebreaks": {
        "title": "Départages",
        "body": [
          "Cela dépend du format.",
          "Au système suisse, dans cet ordre :",
          "1. Buchholz Cut 1 : la somme des scores finaux de tous les adversaires rencontrés, moins le plus faible. Récompense le parcours le plus dur. L'exemption ne compte pas, car ce n'est pas un adversaire.",
          "2. Sonneborn-Berger : les points des adversaires battus, plus la moitié des points de ceux avec qui on a fait nulle. Récompense celui qui a battu les plus forts.",
          "3. Le nombre de victoires.",
          "4. La variation de classement Elo dans le tournoi : combien de points tu as gagnés ou perdus dans les parties de ce tournoi. Elle récompense qui a fait mieux que prévu, pas qui était déjà plus fort. Les joueurs encore à égalité partagent la place.",
          "Au classement, Buchholz et Sonneborn-Berger viennent après les victoires, nulles, défaites et exempts, abrégés en BH et SB.",
          "En toutes rondes, les départages sont différents, car chacun rencontre tout le monde et le Buchholz ne distinguerait personne : d'abord le nombre de victoires, puis la confrontation directe entre les seuls joueurs à égalité, puis le Sonneborn-Berger (SB), enfin la variation de classement Elo dans le tournoi. S'ils sont encore à égalité, passe devant celui qui a le meilleur numéro dans la table, c'est-à-dire le classement le plus élevé au début du tournoi : en toutes rondes, il n'y a pas de places partagées. BH n'y est pas affiché, car lorsque chacun rencontre tout le monde il n'est que le reflet inversé des points. Au classement, «CD» signale qui passe devant grâce à la confrontation directe."
        ]
      },
      "sharedPlaces": {
        "title": "Ex æquo",
        "body": [
          "Dans le système suisse, cela arrive dans les petits tournois quand toutes les parties finissent par une nulle : mêmes points, même Buchholz, même Sonneborn-Berger, aucune victoire.",
          "Dans ce cas, la place est partagée. Deux premiers ex æquo prennent tous les deux l'or, et la place suivante est la troisième : 1, 1, 3, comme dans n'importe quel classement sportif. Personne n'est placé devant un autre à cause de son classement Elo ou de son heure d'inscription.",
          "Une réserve : le palmarès du tournoi ne retient qu'un seul nom comme vainqueur, car cette case n'en accepte qu'un. Le classement et le podium montrent tous les ex æquo."
        ]
      },
      "arena": {
        "title": "L'arène",
        "body": [
          "L'autre compétition qu'on peut ouvrir, et ce n'est pas un tournoi à rondes : elle n'a ni rondes ni calendrier, elle a une durée. Elle s'ouvre, dure de dix minutes à huit heures, et tant qu'elle est ouverte on est réapparié dès qu'on a fini, sans attendre que les autres terminent la leur. On entre et on sort quand on veut, même une fois commencée.",
          "Avec la même personne, en revanche, on attend : cinq minutes pour chaque partie déjà jouée ensemble. La première revanche arrive après cinq minutes, la deuxième après dix, la troisième après quinze, et il n'y a pas de plafond. Cela évite qu'une arène ne devienne le même duel répété sans fin.",
          "Points : victoire 2, nulle 1, défaite zéro, comme au tournoi.",
          "Et il y a le boost, à prendre avant son propre premier coup : il double les points d'une victoire et se paie avec la pendule — l'incrément disparaît entièrement, et le temps de base est divisé par deux. C'est un pari, pas un cadeau.",
          "À égalité de points, c'est celui qui a gagné le plus de parties qui passe devant."
        ]
      }
    },
    "seo": {
      "title": "{{variant}} : règles et comment jouer",
      "description": "Apprenez les règles des {{variant}} : taille du damier, position de départ, comment les pions et les dames se déplacent et capturent, et comment gagner. Jouez aux {{draughtsWord}} en ligne gratuitement.",
      "indexTitle": "Règles des dames — règles du jeu et règles des tournois",
      "indexDescription": "Deux règlements pour les {{draughtsWord}} : les règles du jeu de chaque variante — internationales, italiennes, turques, frisonnes et plus — et les règles de nos tournois en ligne.",
      "gameTitle": "Règles des dames par variante — comment jouer",
      "gameDescription": "Règles et guides pour chaque variante de {{draughtsWord}} : internationales, italiennes, turques, frisonnes, brésiliennes et bien d'autres. Jouez en ligne gratuitement.",
      "openingsTitle": "{{variant}} : tables d’ouverture officielles F.I.D.",
      "openingsDescription": "Les 174 ouvertures officielles du {{variant}} avec leur évaluation et les tables fédérales A, B, C et D. Regolamento Tecnico F.I.D. 2025.",
      "captureTitle": "{{variant}} : toutes les règles de prise",
      "captureDescription": "Toutes les règles de prise de {{variant}} : prise obligatoire, rafle, la hiérarchie qui impose quelle prise jouer, et promotion. Avec des exemples sur le damier.",
      "tournamentsTitle": "Règles des tournois — comment se déroule un tournoi de {{draughtsWord}}",
      "tournamentsDescription": "Les règles des tournois de {{draughtsWord}} en ligne : format toutes rondes/suisse, nombre de rondes, inscription et retrait, absences, tirage de l'ouverture, classement, départages et l'arène."
    },
    "fact": {
      "board": "Se joue sur un damier {{size}}×{{size}}, uniquement sur les cases foncées.",
      "boardAllSquares": "Se joue sur un damier {{size}}×{{size}}, sur toutes les cases.",
      "pieces": "Chaque joueur commence avec {{count}} pièces.",
      "startsWhite": "Les Blancs jouent en premier.",
      "startsBlack": "Les Noirs jouent en premier.",
      "moveDiagonal": "Les pions avancent en diagonale, une case à la fois.",
      "moveOrthogonal": "Les pions se déplacent orthogonalement — en avant et sur les côtés — une case à la fois.",
      "captureDiagonal": "Les prises se font en diagonale, en sautant par-dessus une pièce adverse adjacente.",
      "captureOrthogonal": "Les prises se font orthogonalement, en sautant par-dessus une pièce adverse adjacente.",
      "captureMixed": "Les prises peuvent se faire à la fois en diagonale et orthogonalement.",
      "menCaptureBackwardYes": "Les pions peuvent capturer en avant comme en arrière.",
      "menCaptureBackwardNo": "Les pions ne peuvent capturer qu'en avant.",
      "kingFlying": "Les dames sont \"volantes\" : elles se déplacent et capturent sur un nombre quelconque de cases vides le long d'une ligne.",
      "kingShort": "Les dames se déplacent d'une case à la fois (pas de dames volantes).",
      "menCaptureKingYes": "Les pions peuvent capturer les dames.",
      "menCaptureKingNo": "Les pions ne peuvent pas capturer les dames.",
      "maxCapturePieces": "La prise est obligatoire et il faut jouer la séquence qui capture le plus de pièces.",
      "maxCaptureValue": "La prise est obligatoire et il faut jouer la rafle de plus grande valeur : une dame vaut plus qu'un pion, mais deux pions valent plus qu'une dame.",
      "captureMandatoryFree": "La prise est obligatoire, mais vous pouvez choisir librement laquelle effectuer.",
      "kingPriorityTie": "À prises par ailleurs égales, il faut prendre avec une dame et non avec un pion.",
      "maxKingsCaptureTie": "À nombre de pièces égal, on doit jouer la séquence qui prend le plus de dames.",
      "firstKingFirst": "En cas de nouvelle égalité, il faut choisir la séquence qui prend une dame le plus tôt.",
      "huffing": "La règle du \"souffle\" s'applique : une pièce qui n'a pas capturé peut être retirée.",
      "captureImmediateRemoval": "Chaque pièce prise est retirée immédiatement du damier, ce qui peut ouvrir de nouvelles prises dans la même rafle.",
      "captureNoReversal": "Lors d'une rafle, on peut continuer tout droit ou tourner à 90°, mais jamais faire demi-tour (180°) entre deux sauts.",
      "promotionStops": "Un pion atteignant la dernière rangée est promu et le coup s'arrête, même en pleine prise.",
      "promotionContinues": "Un pion qui traverse la dernière rangée pendant une prise reste pion et poursuit la rafle ; il n'est promu que si le coup se termine sur la dernière rangée.",
      "promotionInPassing": "Un pion qui atteint la dernière rangée pendant une prise est aussitôt promu et poursuit la rafle comme dame volante dans le même tour.",
      "blockedKing": "Tant qu'un joueur a encore des pions, il ne peut pas faire plus de {{n}} coups simples consécutifs avec la même dame ; la dame bloquée peut cependant prendre.",
      "frisianEndgame": "Les règles de nulle frisonnes en finale s'appliquent (ex. deux dames contre une est nulle après un nombre fixé de coups).",
      "loneKingWins": "Si un joueur ne conserve qu'un seul pion face à la dame adverse, le camp de la dame est déclaré vainqueur.",
      "singlePieceLoses": "Le joueur qui ne conserve qu'une seule pièce — pion ou dame — perd immédiatement la partie.",
      "drawLimit": "La partie est nulle après {{n}} coups où seules les dames bougent, sans aucune prise."
    },
    "openings": {
      "title": "Tables d’ouverture",
      "heroSubtitle": "Les 174 ouvertures officielles du {{variant}}, avec leur évaluation et la table fédérale correspondante.",
      "source": "Source : Regolamento Tecnico F.I.D., janvier 2025.",
      "cta": "Tables d’ouverture",
      "ctaDesc": "Les 174 ouvertures officielles et leur évaluation.",
      "intro": "En compétition officielle, les trois premiers demi-coups ne se choisissent pas : ils sont tirés au sort dans une table. La table générale réunit les 174 ouvertures ; les tables fédérales A, B, C et D en sont des sous-ensembles, selon le type de rencontre.",
      "ratedNote": "Dans un défi direct, tu peux plafonner le tirage : jusqu’à 2N/2B une seule partie compte pour le classement, au-delà il faut un match aller-retour.",
      "tableAll": "Générale",
      "tableA": "Table A",
      "tableB": "Table B",
      "tableC": "Table C",
      "tableD": "Table D",
      "count": "{{count}} ouvertures",
      "colNumber": "N°",
      "colOpening": "Ouverture",
      "colStrength": "Évaluation",
      "colStrengthShort": "Éval.",
      "colTables": "Tables",
      "colTablesShort": "Tab.",
      "firstMove": "Premier coup {{move}}",
      "legendTitle": "Comment lire l’évaluation",
      "legendColours": "N = Noir (Nero), B = Blanc (Bianco).",
      "legendPari": "PARI — jeu équilibré.",
      "legend1": "1N / 1B — cette couleur est légèrement mieux, avec plus de choix de lignes.",
      "legend2": "2N / 2B — cette couleur est nettement mieux et l’adversaire se défend.",
      "legend3": "3N / 3B — cette couleur est redoutable : l’adversaire doit manœuvrer avec précision pour annuler.",
      "legend4": "4N / 4B — cette couleur est considérée comme gagnante en l’état des connaissances.",
      "tablesTitle": "Les tables fédérales",
      "italianA": "Uniquement les rencontres en deux parties et les compétitions par paires ou par équipes.",
      "italianB": "Table par défaut des compétitions officielles ; utilisable aussi en une seule partie.",
      "italianC": "Sous-ensemble de B pour les catégories jeunes et provinciales et les tournois promotionnels.",
      "italianD": "Les ouvertures considérées comme gagnantes : rencontres en deux parties uniquement.",
      "englishA": "La table normalement utilisée en rencontres de deux parties et par équipes.",
      "englishB": "Tournois dont les rencontres se jouent en une seule partie.",
      "englishC": "Sous-ensemble de B pour les cas particuliers prévus par les règlements.",
      "englishD": "Les ouvertures considérées comme gagnantes : rencontres en deux parties uniquement.",
      "tableEvery": "Toutes",
      "everyTitle": "Pourquoi 302 ouvertures deviennent 174",
      "everyIntro": "Il existe {{total}} ouvertures légales en trois demi-coups, mais elles ne mènent qu’à {{positions}} positions différentes : la table générale en retient {{listed}}, une par position. Voici le sort des autres.",
      "status_ballot": "Dans la table",
      "statusBallotDesc": "Tirable au sort : c’est une des ouvertures officielles.",
      "statusTransposition": "Comme la n° {{id}}",
      "statusTranspositionShort": "Transposition",
      "statusTranspositionDesc": "Même position finale qu’une ouverture déjà listée, atteinte en changeant l’ordre des coups : ce serait la même partie sous un autre nom.",
      "status_material": "Perd un pion",
      "statusMaterialDesc": "Après le troisième demi-coup, une couleur se retrouve avec un pion de moins et sans reprise : ce sont les deux combinaisons que le règlement exclut depuis toujours.",
      "status_unlisted": "Hors table",
      "statusUnlistedDesc": "Une position que la table ne couvre pas du tout. Aucune raison mécanique : la fédération a sélectionné les lignes à étudier.",
      "statusDecidedDesc": "Elles restent dans la table, mais pour les rencontres en deux parties seulement : considérées gagnantes pour la couleur avantagée, donc perdantes pour l’autre.",
      "colPosition": "Position"
    },
    "capture": {
      "cta": "Les règles de prise",
      "ctaDesc": "La hiérarchie des prises, pas à pas, avec des exemples.",
      "title": "Règles de prise",
      "heroSubtitle": "Quand la prise est obligatoire, quelle prise il faut jouer et comment on compte, aux {{variant}}.",
      "intro": "La prise est la partie la plus réglementée du jeu. Savoir comment on prend ne suffit pas : il faut savoir quelle prise on est obligé de jouer. Toutes les règles sont ici, dans l’ordre exact où le jeu les applique.",
      "source": "Source : Règlement Technique F.I.D., janvier 2025.",
      "mandatoryTitle": "La prise est obligatoire",
      "mandatoryBody": "S’il existe ne serait-ce qu’une prise à votre tour, tous les coups tranquilles disparaissent : ce ne sont pas de mauvais coups, ils n’existent tout simplement pas. L’obligation porte sur toute la position, pas sur une pièce en particulier.",
      "mandatoryRejected": "Se tromper n’est pas puni : une prise contraire aux règles est refusée et la position reste inchangée.",
      "geometryTitle": "Comment se déroule une prise",
      "geometryShortKing": "La dame aussi ne saute qu’une case : la pièce adverse doit être immédiatement voisine en diagonale.",
      "geometryLanding": "La case située derrière la pièce prise doit être libre. Si elle est occupée, par n’importe quelle pièce, ou hors du damier, cette prise n’existe pas.",
      "menVsKingTitle": "Pions et dames",
      "menVsKingWall": "Pour un pion, la dame adverse est un mur : il ne peut ni la prendre ni la franchir. Une dame placée devant un groupe de pièces les rend intouchables par les pions.",
      "menVsKingFree": "Aucune restriction de rang : n’importe quelle pièce peut prendre n’importe quelle pièce.",
      "multiTitle": "La prise multiple",
      "multiBody": "Si après un saut la pièce se retrouve devant une pièce prenable, elle doit continuer. S’arrêter en chemin n’est pas un choix : une séquence incomplète n’est pas un coup légal.",
      "multiDirection": "On peut changer de direction à chaque saut. Le pion, lui, n’alterne qu’entre ses deux diagonales avant : il n’acquiert jamais la prise en arrière pendant la séquence.",
      "multiNoTwice": "La même pièce adverse ne peut pas être sautée deux fois dans la même séquence. La même case vide, en revanche, peut être traversée autant de fois que nécessaire.",
      "ladderTitle": "La hiérarchie des prises",
      "ladderIntro": "Lorsque plusieurs prises sont possibles, le choix ne vous appartient pas. Le jeu les compare selon ces critères, dans cet ordre : on ne passe au critère suivant que si le précédent laisse plusieurs prises à égalité.",
      "ladderWholePosition": "La comparaison porte sur toutes les prises de toutes vos pièces. Une pièce peut donc rester immobile parce qu’une autre a une meilleure prise.",
      "ladderNoneIntro": "La prise est obligatoire, mais quelle prise jouer reste entièrement libre. Il n’existe aucune hiérarchie : une prise simple vaut autant qu’une rafle, et rien n’oblige à prendre davantage.",
      "levelLabel": "Niveau {{n}}",
      "levelMaxPieces": "Il faut jouer la prise qui capture le plus grand nombre de pièces.",
      "whyMaxPieces": "On compte les pièces, pas leur valeur : deux pions l’emportent sur une dame.",
      "levelMaxValue": "Il faut jouer la prise dont la valeur totale est la plus élevée.",
      "whyMaxValue": "Les dames pèsent plus que les pions, donc la séquence la plus longue ne gagne pas toujours.",
      "levelWithKing": "À nombre de pièces égal, il faut prendre avec la dame et non avec le pion.",
      "whyWithKing": "Le critère porte sur la pièce qui prend, pas sur celle qui est prise. Si une dame et un pion prennent le même nombre de pièces, c’est à la dame de jouer, même quand le pion prendrait des pièces plus précieuses.",
      "levelMaxKings": "À nouvelle égalité, il faut jouer la prise qui capture le plus de dames.",
      "whyMaxKings": "Ici compte la valeur de ce que l’on retire à l’adversaire. Comme seules les dames peuvent prendre des dames, ce critère ne départage que des prises de dame.",
      "levelFirstKing": "À nouvelle égalité, il faut choisir la séquence qui prend une dame le plus tôt.",
      "whyFirstKing": "On regarde l’ordre des sauts : entre deux trajets prenant les mêmes pièces, celui qui rencontre la dame au saut le plus précoce l’emporte.",
      "levelFree": "Si les prises restent équivalentes, le choix est libre.",
      "whyFree": "Au-delà de ce point aucune règle ne contraint le joueur : deux prises identiques sur tous les critères se jouent indifféremment.",
      "removalTitle": "Quand les pièces quittent le damier",
      "removalEnd": "Les pièces prises restent sur le damier jusqu’à la fin du coup et sont retirées toutes ensemble une fois la séquence achevée. C’est pourquoi on les voit encore en place pendant une prise multiple.",
      "removalImmediate": "La case libérée redevient disponible aussitôt. Sauter deux fois la même pièce reste interdit.",
      "promotionTitle": "La promotion arrête la prise",
      "promotionBody": "Si le pion atteint la dernière rangée au cours d’une séquence, le coup s’arrête là : le pion devient dame et le trait passe à l’adversaire, même si d’autres sauts seraient possibles depuis cette case. La nouvelle dame ne joue qu’au coup suivant.",
      "promotionNoExemption": "La promotion ne dispense pas de la hiérarchie : la séquence interrompue est comparée sur les pièces qu’elle a réellement prises. Si une autre prise en capture davantage, celle qui promeut est illégale.",
      "promotionStillAMan": "Pour la hiérarchie, un pion qui promeut compte encore comme un pion : il n’acquiert pas la priorité de la dame.",
      "noHuffingTitle": "Pas de soufflage",
      "noHuffingBody": "La règle du \"soufflage\" ne s’applique pas : qui manque une prise obligatoire ne perd pas la pièce, il ne peut simplement pas jouer ce coup.",
      "exGeometry": "Les Blancs sautent la pièce voisine et se posent juste derrière.",
      "exMenVsKingWall": "Le pion est à côté d’une dame adverse et ne peut pas la prendre : il ne lui reste qu’un coup tranquille.",
      "exMenVsKingFree": "Ici le pion prend la dame comme n’importe quelle autre pièce.",
      "exMulti": "Un seul coup légal : la séquence doit être menée jusqu’au bout.",
      "exPromotion": "Les Blancs atteignent la dernière rangée : le coup s’arrête là, même s’il restait une pièce à prendre.",
      "exMaxPieces": "Deux prises possibles : l’une capture une pièce, l’autre deux. Seule la plus longue est légale.",
      "exMaxValue": "Parmi les prises possibles, c’est la valeur totale des pièces prises qui décide.",
      "exWithKing": "La dame et le pion prennent une pièce chacun : c’est la dame qui doit jouer.",
      "exMaxKings": "Deux dames peuvent prendre : il faut capturer la dame adverse, pas le pion.",
      "exFirstKing": "Deux trajets de deux pièces avec une dame chacun : celui qui prend la dame en premier est obligatoire.",
      "exFree": "La même boucle, dans les deux sens, prend les mêmes quatre pièces : on peut choisir.",
      "exFreeNoLadder": "Une prise capture une pièce, l’autre deux : ici les deux sont légales.",
      "forced": "Coup obligatoire",
      "choices": "Coups légaux",
      "diagramAlt": "Position d’exemple"
    },
    "gameRulesHead": "Règles du jeu"
  },
  "faq": {
    "title": "FAQ & Contact",
    "intro": "Questions fréquentes et canal direct pour les problèmes, demandes et retours.",
    "questionsTitle": "Questions fréquentes",
    "entries": [
      {
        "id": "install-android",
        "q": "Comment installer l'application sur Android ?",
        "a": "L'application s'installe directement depuis le navigateur : pas besoin du Play Store.\n1. Ouvre le site avec Chrome (ou Edge, Samsung Internet).\n2. Appuie sur le menu ⋮ en haut à droite.\n3. Choisis \"Installer l'application\" (ou \"Ajouter à l'écran d'accueil\") et confirme.\nLe navigateur propose parfois lui-même une bannière d'installation : tu peux l'utiliser aussi. L'icône rejoint tes autres applications et le jeu s'ouvre en plein écran, sans la barre du navigateur."
      },
      {
        "id": "install-ios",
        "q": "Comment installer l'application sur iPhone ou iPad ?",
        "a": "Sur iPhone et iPad, la procédure est différente et doit se faire dans Safari.\n1. Ouvre le site avec Safari (dans les autres navigateurs, l'option peut ne pas apparaître).\n2. Appuie sur le bouton Partager (le carré avec une flèche vers le haut) : en bas sur iPhone, en haut sur iPad.\n3. Fais défiler la liste et choisis \"Sur l'écran d'accueil\".\n4. Appuie sur \"Ajouter\" en haut à droite.\niOS n'affiche jamais de proposition automatique d'installation : sans ces étapes, aucune icône n'est créée."
      },
      {
        "id": "install-desktop",
        "q": "Puis-je installer l'application sur mon ordinateur ?",
        "a": "Oui, avec Chrome ou Edge.\n1. Ouvre le site.\n2. Clique sur l'icône d'installation à droite dans la barre d'adresse, ou ouvre le menu du navigateur et choisis \"Installer…\".\n3. Confirme : l'application s'ouvre dans sa propre fenêtre, sans la barre du navigateur.\nFirefox et Safari sur ordinateur ne gèrent pas l'installation — tu peux jouer normalement dans le navigateur et ajouter le site aux favoris."
      },
      {
        "id": "login",
        "q": "Je n'arrive pas à me connecter à mon compte — que faire ?",
        "a": "Vérifie que ton e-mail et ton mot de passe sont corrects. Si tu as oublié ton mot de passe, utilise le lien \"Mot de passe oublié\" sur l'écran de connexion. Si le problème persiste, remplis le formulaire ci-dessous et choisis la catégorie \"Problème de connexion\"."
      },
      {
        "id": "verify-email",
        "q": "Je n'ai pas reçu l'e-mail de vérification — comment l'obtenir à nouveau ?",
        "a": "Ouvre la fenêtre de connexion, essaie de te connecter avec tes identifiants et clique sur \"Renvoyer l'e-mail de vérification\". Pense aussi à vérifier ton dossier spam."
      },
      {
        "id": "variant-request",
        "q": "Puis-je proposer une nouvelle variante de dames ?",
        "a": "Oui ! Remplis le formulaire de contact ci-dessous, choisis \"Demande de nouvelle variante\" et décris les règles de la variante que tu aimerais voir prise en charge."
      },
      {
        "id": "rules-wrong",
        "q": "Les règles d'une variante semblent incorrectes — comment le signaler ?",
        "a": "Remplis le formulaire de contact ci-dessous et choisis \"Correction de règles\". Indique la variante concernée et décris la règle à corriger, idéalement avec un lien vers la source officielle (FMJD, FID, WCDF, etc.)."
      },
      {
        "id": "delete-account",
        "q": "Comment supprimer mon compte ?",
        "a": "Ouvre les paramètres de ton profil : tu y trouveras les options pour exporter tes données (RGPD) et pour supprimer définitivement ton compte. La suppression est irréversible."
      }
    ],
    "contactTitle": "Contactez-nous",
    "contactIntro": "Pas trouvé de réponse ? Écris-nous et nous te répondrons par e-mail.",
    "category": {
      "login": "Problème de connexion",
      "variant_request": "Demande de nouvelle variante",
      "rules": "Correction de règles",
      "other": "Autre"
    },
    "fields": {
      "name": "Nom (facultatif)",
      "email": "E-mail",
      "category": "Catégorie",
      "subject": "Objet",
      "message": "Message"
    },
    "submit": "Envoyer la demande",
    "success": "Merci ! Ta demande a été envoyée. Nous te répondrons par e-mail dès que possible.",
    "errors": {
      "invalidEmail": "Saisis une adresse e-mail valide.",
      "subjectTooShort": "L'objet doit contenir au moins 3 caractères.",
      "messageTooShort": "Le message doit contenir au moins 10 caractères.",
      "rateLimited": "Tu as envoyé trop de demandes récemment. Réessaie dans une heure.",
      "submitFailed": "L'envoi a échoué. Vérifie ta connexion et réessaie."
    }
  },
  "home": {
    "heroTitle": "Jeu de Dames",
    "heroTagline": "La plateforme de jeu de dames internationale, italienne et anglaise. Jouez, participez aux tournois et grimpez au classement.",
    "welcome": "Bienvenue",
    "newGame": "Nouvelle Partie",
    "chooseMode": "Choisissez votre mode de jeu",
    "startNow": "Jouer",
    "vsAI": "Jouer contre l'IA",
    "vsAIDesc": "Entraînez-vous contre l'ordinateur",
    "vsOnline": "Jouer en Ligne",
    "vsOnlineDesc": "Défiez de vrais joueurs",
    "vsFriends": "Jouer avec des Amis",
    "vsFriendsDesc": "Créez ou rejoignez une partie privée",
    "createTable": "Créer Table",
    "createTableDesc": "Invitez un ami à jouer",
    "joinTable": "Rejoindre Table",
    "joinTableDesc": "Entrez un code de salle",
    "enterRoomCode": "Entrez le code partagé par votre ami",
    "variant": "Variante",
    "difficulty": "Difficulté",
    "timeControl": "Contrôle du Temps",
    "startGame": "Démarrer la Partie",
    "playersOnline": "joueurs en ligne",
    "gamesInProgress": "parties en cours",
    "landing": {
      "heroTitle": "Jouez aux Dames",
      "heroTitleAccent": "en Ligne",
      "heroTagline": "Des variantes de dames du monde entier. Tournois, parties classées, adversaires IA — jouez maintenant.",
      "playFree": "Jouer Maintenant",
      "signUp": "S'inscrire",
      "playAsGuest": "Jouer en tant qu'Invité",
      "featuresLabel": "Pourquoi les Dames ?",
      "featuresTitle": "Tout ce qu'il faut pour jouer",
      "featuresSubtitle": "Une plateforme complète pour les joueurs de dames compétitifs et occasionnels.",
      "featureTournaments": "Tournois",
      "featureTournamentsDesc": "Formats Swiss et Arena avec appariement automatique, classement Glicko-2 et classements en temps réel.",
      "featureRating": "Système de Classement",
      "featureRatingDesc": "Classements Glicko-2 séparés par variantes et cadences. Suivez votre progression.",
      "featureAI": "Adversaires IA",
      "featureAIDesc": "6 niveaux de difficulté du débutant à l'expert. Entraînez-vous à tout moment.",
      "featureVariants": "Variantes du Monde",
      "featureVariantsDesc": "Des dames internationales et italiennes au turc, frison et plus — des variantes de dames du monde entier.",
      "featureOnline": "Jeu en ligne",
      "featureOnlineDesc": "Trouvez un adversaire en quelques secondes grâce au matchmaking et jouez des parties classées ou amicales.",
      "featurePuzzles": "Problèmes quotidiens",
      "featurePuzzlesDesc": "Un nouveau problème chaque jour sur plusieurs variantes. Aiguisez votre tactique et faites grimper votre classement.",
      "specBoard": "Plateau {{size}}",
      "specPieces": "{{count}} pièces par camp",
      "specFlyingKings": "Dames volantes",
      "specShortKings": "Dames courtes",
      "howLabel": "Comment ?",
      "howTitle": "Commencez à jouer en quelques secondes",
      "step1Title": "Créez un Compte",
      "step1Desc": "Inscrivez-vous en quelques secondes. Ou jouez instantanément en tant qu'invité.",
      "step2Title": "Choisissez Votre Partie",
      "step2Desc": "Choisissez la variante, la cadence et jouez contre d'autres joueurs ou l'IA.",
      "step3Title": "Grimpez au Classement",
      "step3Desc": "Gagnez des parties, accumulez des points et participez aux tournois quotidiens.",
      "variantsLabel": "Variantes de Jeu",
      "variantsTitle": "Toutes les variantes de dames, une plateforme",
      "variantsMoreTitle": "Et bien d'autres variantes",
      "variantsAllCta": "Voir les règles de chaque variante",
      "intlBadge": "FMJD Officiel",
      "intlDesc": "Le standard du jeu de dames compétitif mondial. Dames volantes, prise obligatoire et règle de la prise la plus longue.",
      "italianBadge": "Traditionnel",
      "italianDesc": "La tradition italienne bien-aimée. Les pions ne peuvent pas capturer les dames et la règle du plus grand nombre de pièces capturées crée un jeu tactique profond.",
      "englishBadge": "WCDF Officiel",
      "englishDesc": "Jeu de dames classique 8×8 joué dans le monde entier. Capture obligatoire, dames non volantes, les pions peuvent capturer les dames et aucun mouvement en arrière pour les pions.",
      "brazilianBadge": "Populaire",
      "brazilianDesc": "La variante préférée du Brésil. Plateau 8×8 avec dames volantes, prise la plus longue obligatoire et pions capturant en arrière.",
      "ctaTitle": "Prêt à jouer ?",
      "ctaSubtitle": "Rejoignez la communauté. Lancez votre première partie.",
      "ctaButton": "Commencer à Jouer",
      "heroCta": "Jouer maintenant",
      "puzzleTitle": "Essayez un puzzle",
      "puzzleSubtitle": "Résolvez cette position tout de suite, sans inscription. Créez ensuite un compte gratuit pour jouer le puzzle du jour et faire grimper votre classement."
    },
    "dashboard": {
      "welcomeBack": "Bon retour",
      "recentGames": "Parties Récentes",
      "viewAll": "Voir Tout",
      "liveUpcoming": "En Direct & À Venir",
      "allTournaments": "Tous les Tournois",
      "thisWeek": "cette semaine",
      "live": "EN DIRECT",
      "join": "Rejoindre",
      "noRecentGames": "Aucune partie encore. Jouez votre première !",
      "noTournaments": "Aucun tournoi à venir.",
      "timeAgo": {
        "now": "à l'instant",
        "minutes": "il y a {{count}} min",
        "hours": "il y a {{count}}h",
        "yesterday": "Hier",
        "days": "il y a {{count}}j",
        "weeks": "il y a {{count}}sem",
        "months": "il y a {{count}}m"
      },
      "dailyPuzzle": {
        "title": "Puzzle du jour",
        "whiteToMove": "Les blancs jouent",
        "blackToMove": "Les noirs jouent"
      }
    }
  },
  "game": {
    "header": {
      "rated": "Classée",
      "casual": "Amicale",
      "variantRules": "Règles de la variante"
    },
    "variants": {
      "international": "Dames Internationales 10×10",
      "internationalShort": "Internationales 10×10",
      "internationalMedium": "Internationales 10×10",
      "italian": "Dames Italiennes 8×8",
      "italianShort": "Italien 8×8",
      "english": "Dames Anglaises 8×8",
      "englishShort": "Anglais 8×8",
      "englishBadge": "WCDF Officiel",
      "englishDesc": "Jeu de dames classique 8×8 joué dans le monde entier. Capture obligatoire, dames non volantes, les pions peuvent capturer les dames et aucun mouvement en arrière pour les pions.",
      "brazilian": "Jeu de Dames Brésilien 8×8",
      "brazilianShort": "Brésilien 8×8",
      "frisian": "Jeu de Dames Frison 10×10",
      "frisianShort": "Frison 10×10",
      "frysk": "Frysk! 10×10",
      "fryskShort": "Frysk 10×10",
      "turkish": "Jeu de Dames Turc 8×8",
      "turkishShort": "Turc 8×8",
      "armenian": "Tama Arménien 8×8",
      "armenianShort": "Arménien 8×8",
      "russian": "Jeu de Dames Russe 8×8",
      "russianShort": "Russe 8×8",
      "spanish": "Jeu de Dames Espagnol 8×8",
      "spanishShort": "Espagnol 8×8",
      "triestine": "Jeu de Dames Triestin 10×10",
      "triestineShort": "Triestin 10×10",
      "canadian": "Jeu de Dames Canadien 12×12",
      "canadianShort": "Canadien 12×12",
      "nigerian": "Jeu de Dames Nigérian 10×10",
      "nigerianShort": "Nigérian 10×10",
      "ghanaian": "Jeu de Dames Ghanéen 10×10",
      "ghanaianShort": "Ghanéen 10×10",
      "pool": "Pool Checkers 8×8",
      "poolShort": "Pool 8×8",
      "czech": "Jeu de Dames Tchèque 8×8",
      "czechShort": "Tchèque 8×8",
      "thai": "Makhos Thaï 8×8",
      "thaiShort": "Thaï 8×8",
      "portuguese": "Jeu de Dames Portugais 8×8",
      "portugueseShort": "Portugais 8×8",
      "filipino": "Jeu de Dames Philippin 8×8",
      "filipinoShort": "Philippin 8×8",
      "malaysian": "Jeu de Dames Malaisien 12×12",
      "malaysianShort": "Malaisien 12×12",
      "german": "Damenspiel Allemand 8×8",
      "germanShort": "Allemand 8×8",
      "jamaican": "Jeu de Dames Jamaïcain 8×8",
      "jamaicanShort": "Jamaïcain 8×8",
      "sinhalese": "Jeu de Dames Cinghalais 8×8",
      "sinhaleseShort": "Cinghalais 8×8",
      "south_african": "Jeu de Dames Sud-Africain 14×14",
      "south_africanShort": "Sud-Africain 14×14",
      "dameo": "Dameo 8×8",
      "dameoShort": "Dameo 8×8",
      "croda": "Croda 8×8",
      "crodaShort": "Croda 8×8"
    },
    "opponent": {
      "computer": "AI"
    },
    "modes": {
      "twoPlayers": "2 Joueurs",
      "aiVeryEasy": "Très Facile",
      "aiEasy": "Facile",
      "aiMedium": "Moyen",
      "aiHard": "Difficile",
      "aiExpert": "Très Difficile",
      "aiMaster": "Expert",
      "playOnline": "Jouer en Ligne"
    },
    "timeControls": {
      "noTimeLimit": "Sans Limite de Temps",
      "blitz30": "Blitz 3+0",
      "blitz32": "Blitz 3+2",
      "blitz50": "Blitz 5+0",
      "blitz53": "Blitz 5+3",
      "rapid105": "Rapide 10+5",
      "rapid1510": "Rapide 15+10"
    },
    "turn": {
      "yourTurn": "Votre tour",
      "opponentTurn": "Tour de l'adversaire",
      "toMove": "Au trait",
      "aiThinking": "L'IA réfléchit...",
      "aiTurn": "Tour de l'IA",
      "aiDeclinedDraw": "L'ordinateur a refusé la nulle",
      "whiteToMove": "Les blancs jouent",
      "blackToMove": "Les noirs jouent"
    },
    "result": {
      "youWin": "Vous Gagnez !",
      "youLose": "Vous Perdez !",
      "draw": "Match Nul !",
      "whiteWins": "Les Blancs Gagnent !",
      "blackWins": "Les Noirs Gagnent !",
      "gameOver": "Partie Terminée",
      "gameAbandoned": "Partie Abandonnée",
      "noWinner": "Partie interrompue",
      "won": "Victoire",
      "lost": "Défaite"
    },
    "drawCountdown": {
      "aria_one": "Nulle automatique dans {{count}} coup si seules les dames bougent",
      "aria_other": "Nulle automatique dans {{count}} coups si seules les dames bougent"
    },
    "frisianCountdown": {
      "aria_one": "Nulle automatique dans {{count}} coup : deux dames contre une",
      "aria_other": "Nulle automatique dans {{count}} coups : deux dames contre une"
    },
    "endReason": {
      "checkmate": "sans coups",
      "noLegalMoves": "n'a plus de coups légaux.",
      "whiteNoMoves": "Les blancs n'ont plus de coups légaux.",
      "blackNoMoves": "Les noirs n'ont plus de coups légaux.",
      "drawEnded": "La partie s'est terminée par un match nul.",
      "gameAbandoned": "La partie a été abandonnée.",
      "noWinner": "La partie s'est terminée sans vainqueur.",
      "gameEnded": "La partie est terminée.",
      "resignation": "abandon",
      "disconnection": "déconnexion",
      "fiftyMoves": "50 coups",
      "timeout": "temps écoulé",
      "agreement": "nulle par accord",
      "walkover": "forfait",
      "firstKing": "Première dame",
      "sideResigned": "{{side}} a abandonné.",
      "sideTimeout": "{{side}} a dépassé le temps.",
      "sideNoPieces": "{{side}} n'a plus de pièces.",
      "moveLimit": "Trop de coups sans prise.",
      "repetition": "Même position répétée trois fois.",
      "endgameDraw": "Finale théoriquement nulle.",
      "sideZugzwang": "{{side}} est en zugzwang : tout coup perd.",
      "loneKing": "La dame seule bat le pion seul.",
      "sideSinglePiece": "{{side}} n'a plus qu'une seule pièce.",
      "drawAgreed": "Nulle par accord.",
      "sideNoFirstMove": "{{side}} n'a pas joué à temps.",
      "noFirstMove": "Premier coup non joué à temps."
    },
    "actions": {
      "newGame": "Nouvelle Partie",
      "resign": "Abandonner",
      "endGame": "Terminer",
      "leaveGame": "Quitter la Partie",
      "backToLobby": "Retour au Salon",
      "offerDraw": "Nulle",
      "drawOffered": "Votre adversaire propose la nulle",
      "drawSent": "Nulle proposée…",
      "acceptDraw": "Accepter",
      "declineDraw": "Refuser",
      "drawDeclined": "Votre adversaire a refusé la nulle",
      "drawMoveFirst": "Jouez d'abord",
      "drawMustMoveFirst": "Jouez un coup avant de proposer la nulle à nouveau.",
      "drawNoneLeft": "Plus de propositions",
      "drawLimitReached": "Vous avez utilisé toutes vos propositions de nulle dans cette partie.",
      "drawTooFast": "Trop de propositions de nulle. Attendez un instant.",
      "requestTakeback": "Reprendre le coup",
      "takebackRequested": "Demande de reprise envoyée…",
      "opponentRequestsTakeback_one": "L'adversaire demande de reprendre {{count}} coup",
      "opponentRequestsTakeback_other": "L'adversaire demande de reprendre {{count}} coups",
      "acceptTakeback": "Accepter",
      "declineTakeback": "Refuser",
      "takebackDeclined": "Votre demande de reprise a été refusée",
      "takebackAccepted": "Votre demande de reprise a été acceptée",
      "takebackDisabledRated": "La reprise de coup est désactivée en parties classées",
      "focus": "Focus",
      "focusExit": "Quitter",
      "peek": "Coup d'œil",
      "boardSize": "Taille du damier",
      "boardBigger": "Damier plus grand",
      "boardSmaller": "Damier plus petit",
      "flipBoard": "Pivoter"
    },
    "confirmLeave": "Êtes-vous sûr de vouloir quitter la partie ?",
    "confirmLeaveTitle": "Quitter la partie ?",
    "confirmLeaveCancel": "Annuler",
    "confirmLeaveButton": "Quitter",
    "confirmResignTitle": "Abandonner ?",
    "confirmResign": "Êtes-vous sûr de vouloir abandonner ? Vous perdrez la partie.",
    "confirmEndGameTitle": "Terminer la partie ?",
    "confirmEndGame": "La partie se terminera sans vainqueur.",
    "clock": {
      "white": "Blancs",
      "black": "Noirs"
    },
    "aborted": {
      "opponentLeft": "Ton adversaire est parti avant le début de la partie — recherche d'un nouvel adversaire…",
      "opponentDidNotMove": "L'adversaire n'a pas joué à temps — partie annulée."
    },
    "disconnection": {
      "opponentDisconnected": "Adversaire Déconnecté",
      "waitingToReconnect": "En attente de la reconnexion de l'adversaire...",
      "opponentLeft": "L'adversaire a quitté la partie",
      "disconnected": "Déconnecté",
      "notPresent": "Absent",
      "avvisoMaiArrivato": "Adversaire pas encore là : s'il n'arrive pas, vous gagnez quand sa pendule tombe.",
      "avvisoDecideOrologio": "Adversaire déconnecté : s'il ne revient pas, vous gagnez quand sa pendule tombe.",
      "avvisoGrazia": "Adversaire déconnecté : s'il ne revient pas d'ici {{secondi}} s, vous gagnez.",
      "avvisoMaiArrivatoTuoTurno": "Adversaire pas encore là : jouez votre coup ; s'il n'arrive pas, vous gagnez quand sa pendule tombe.",
      "avvisoDecideOrologioTuoTurno": "Adversaire déconnecté : jouez votre coup ; s'il ne revient pas, vous gagnez quand sa pendule tombe."
    },
    "sidebar": {
      "moves": "Coups",
      "openingNumbered": "Ouverture n° {{n}}",
      "openingDrawn": "Ouverture tirée au sort",
      "chat": "Chat",
      "spectators": "Spectateurs",
      "noMoves": "Aucun coup",
      "viewMove": "Voir la position après le coup {{n}}",
      "goToStart": "Aller au début",
      "prevMove": "Coup précédent",
      "nextMove": "Coup suivant",
      "goLive": "Aller à la position actuelle",
      "play": "Lecture",
      "pause": "Pause",
      "position": "Position dans la ligne",
      "showMoves": "Afficher les coups",
      "hideMoves": "Masquer les coups"
    },
    "blind": {
      "lastMove": "Dernier coup",
      "promoted": "Dame",
      "noPeeks": "Partie jouée sans un seul coup d'œil.",
      "peeks_one": "Tu as jeté {{count}} coup d'œil.",
      "peeks_other": "Tu as jeté {{count}} coups d'œil."
    },
    "confirmDrawTitle": "Nulle ?",
    "confirmDraw": "Terminer la partie sur une nulle ? Les deux joueurs doivent être d’accord.",
    "match": {
      "playReturn": "Jouer la manche retour"
    },
    "primaMossa": {
      "secondi_one": "{{count}}s",
      "secondi_other": "{{count}}s",
      "ariaVoid_one": "Premier coup sous {{count}} seconde, sinon la partie est annulée",
      "ariaVoid_other": "Premier coup sous {{count}} secondes, sinon la partie est annulée",
      "ariaForfeit_one": "Premier coup sous {{count}} seconde, sinon défaite par forfait",
      "ariaForfeit_other": "Premier coup sous {{count}} secondes, sinon défaite par forfait"
    },
    "saluto": {
      "invia": "Souhaiter une bonne partie à ton adversaire",
      "mittente": "{{username}} :",
      "ancheATe": "À toi aussi",
      "inviato": "Salutation envoyée"
    }
  },
  "online": {
    "title": "Jeu en Ligne",
    "playOnline": "Jouer en Ligne",
    "connecting": "Connexion au serveur...",
    "connectionFailed": "Connexion Échouée",
    "couldNotConnect": "Impossible de se connecter au serveur de jeu.",
    "error": "Erreur",
    "room": {
      "title": "Salle",
      "code": "Code de salle",
      "shareCode": "Partagez ce code de salle :",
      "playAs": "Vous jouez",
      "waitingForOpponent": "En Attente d'un Adversaire"
    },
    "lobby": {
      "findMatch": "Trouver une Partie",
      "matchmakingByRating": "Matchmaking automatique par classement",
      "signInToMatch": "Connectez-vous pour utiliser le matchmaking automatique",
      "createGame": "Créer une Partie",
      "selectVariantAndTime": "Sélectionner variante et cadence",
      "createRoom": "Créer une Salle",
      "joinGame": "Rejoindre une Partie",
      "enterRoomCode": "Entrez un code de salle pour rejoindre",
      "join": "Rejoindre",
      "playWithFriends": "ou jouer avec des amis"
    },
    "matchmaking": {
      "findingOpponent": "Recherche d'Adversaire...",
      "matchingSimilarSkill": "Recherche d'un joueur de niveau similaire...",
      "creatingRoom": "Création de la salle...",
      "joiningRoom": "Entrée dans la salle...",
      "estimatedWait": "Attente estimée : ~{{seconds}}s",
      "timeout": "Aucun adversaire trouvé. Réessayez."
    },
    "errors": {
      "authRequired": "Vous devez être connecté pour jouer en ligne.",
      "alreadyInQueue": "Vous recherchez déjà une partie.",
      "alreadyInGame": "Vous êtes déjà en partie.",
      "generico": "Quelque chose a mal tourné. Réessayez.",
      "nonConnesso": "Vous n’êtes pas connecté au serveur.",
      "partitaSparita": "Cette partie n’existe plus.",
      "drawOfferFailed": "Impossible de proposer la nulle.",
      "serverRestart": "Le serveur redémarre : la partie reprendra sous peu. Si elle ne revient pas, rechargez la page.",
      "sfidaTroppeRichieste": "Vous avez envoyé trop de défis d’affilée. Attendez un instant.",
      "avversarioOffline": "Ce joueur s’est déconnecté.",
      "avversarioInPartita": "Ce joueur est déjà en partie. Réessayez quand il aura fini.",
      "seiInGara": "Vous participez à un tournoi ou à une arène en cours : terminez-le d’abord.",
      "avversarioInGara": "Ce joueur dispute un tournoi ou une arène.",
      "troppePosizioni": "Trop de positions personnalisées d’affilée. Attendez un instant.",
      "impostazioniNonValide": "Ces réglages ne sont pas valides. Vérifiez-les et réessayez.",
      "soloIscritti": "Ce joueur ne peut disputer que des parties amicales.",
      "sfidaGiaInVolo": "Vous avez déjà un défi en attente de réponse. Annulez-le d’abord.",
      "sfidaGiaMandata": "Vous avez déjà défié ce joueur : attendez sa réponse."
    },
    "challenge": {
      "challenge": "Défier",
      "sendChallenge": "Défi direct",
      "incomingChallenge": "Défi Entrant",
      "tabBadge": "Défi !",
      "send": "Envoyer",
      "accept": "Accepter",
      "decline": "Refuser",
      "cancel": "Annuler",
      "loginRequired": "Connectez-vous pour voir les joueurs en ligne et envoyer des défis",
      "waitingForResponse": "En attente de {{username}}...",
      "declined": "Défi refusé",
      "expired": "Défi expiré",
      "cancelled": "Défi annulé",
      "color": "Couleur",
      "gameType": "Type de partie",
      "colorRandom": "Aléatoire",
      "rated": "Classée (sans invités)",
      "casual": "Amicale",
      "gameTypeAny": "Classée/Amicale",
      "registeredOnly": "Inscrits seulement",
      "registeredOnlyNote": "Seuls les joueurs inscrits peuvent jouer cette partie.",
      "opponentGuestNoRated": "Cet adversaire est un invité : la partie ne peut pas être classée.",
      "mode": "Mode",
      "modeNormal": "Standard",
      "modeBreakthrough": "Breakthrough",
      "modeAntidraughts": "Antijeu",
      "modeBlind": "À l'aveugle",
      "modeInfoLabel": "À propos des modes de jeu",
      "modeBreakthroughInfo": "Le premier joueur qui promeut un pion en dame gagne immédiatement.",
      "modeAntidraughtsInfo": "Objectif inversé : gagne qui n'a plus de pièces, ou plus de coup légal.",
      "modeBlindInfo": "Les pièces sont invisibles : on joue de mémoire, comme les yeux bandés. Les règles restent les règles normales.",
      "opening": "Ouverture",
      "legs": "Parties",
      "legsOne": "Aller seulement",
      "legsTwo": "Aller-retour",
      "openingDrawnSingleLegCasual": "Avec cette ouverture, une seule partie ne compense pas l’avantage du tirage : la partie est toujours amicale.",
      "time": "Temps",
      "increment": "Incrément",
      "noClockCasual": "Les parties sans limite de temps sont toujours amicales.",
      "link": {
        "inviteFriend": "Inviter un ami",
        "title": "Défier un ami",
        "intro": "Envoie ce lien à qui tu veux : la première personne qui l'ouvre joue contre toi, même sans compte.",
        "share": "Partager",
        "copy": "Copier le lien",
        "copied": "Copié !",
        "copyFailed": "Impossible de copier le lien. Sélectionne-le et copie-le à la main.",
        "expiresIn": "Le lien est encore valable {{time}}.",
        "startingSoon": "La partie va commencer...",
        "friendAccepted": "{{name}} a accepté ton défi !",
        "cancelLink": "Annuler le défi",
        "shareTitle": "Défi de dames",
        "shareText": "Fais une partie de dames avec moi !",
        "shareTextWith": "Fais une partie de dames avec moi — {{summary}}",
        "challengesYou": "{{name}} te défie aux dames",
        "playNow": "Jouer maintenant",
        "haveAccount": "J'ai déjà un compte",
        "guestCasualNote": "En jouant comme invité, la partie est amicale (sans effet sur le classement).",
        "waitingChallengerTitle": "Défi accepté",
        "waitingChallenger": "En attente du retour de {{name}}. La partie démarrera toute seule.",
        "unavailableTitle": "Défi indisponible",
        "cancelledByChallenger": "La personne qui t'a défié a annulé la partie.",
        "expiredOrGone": "Ce lien a expiré ou n'est plus valable. Demande-en un nouveau à ton ami.",
        "backHome": "Retour à l'accueil"
      },
      "opening_free": "Coup libre",
      "opening_random1": "1 coup au hasard quelconque",
      "opening_random2": "2 coups au hasard quelconques",
      "opening_random3": "3 coups au hasard quelconques",
      "opening_ballot1": "Table C - 1N/1B",
      "opening_ballot2": "Table B - 2N/2B",
      "opening_ballot3": "Table {{tables}} - 3N/3B",
      "opening_ballot4": "Table générale",
      "opening_single": "Ouverture fixe",
      "openingInfoLabel": "À propos des ouvertures",
      "openingInfo": "Les entrées « Table » tirent dans les tables officielles F.I.D. : le nombre entre parenthèses indique parmi combien d’ouvertures se fait le tirage, et le plafond (1N/1B … 4N/4B) limite le déséquilibre possible. Jusqu’à la Table B, une seule partie compte pour le classement ; au-delà, il faut un match aller-retour. Les entrées « au hasard » tirent au contraire parmi tous les coups légaux, sans aucun plafond : à partir de 2 coups, elles exigent un aller-retour.",
      "openingInfoRandom": "Les premiers demi-coups sont tirés au sort parmi tous les coups légaux : le nombre entre parenthèses indique combien de combinaisons différentes peuvent sortir. Cette variante n’a pas de tables d’ouverture officielles. À partir de 2 coups, le tirage peut favoriser une couleur : la partie ne compte alors pour le classement qu’en aller-retour.",
      "openingTablesLink": "Voir les tables d’ouverture",
      "guestCannotChallenge": "Les défis directs sont réservés aux joueurs inscrits. Connecte-toi ou crée un compte gratuit pour en envoyer.",
      "guestCasualInvite": "Connecte-toi ou crée un compte gratuit pour jouer des parties classées.",
      "changeOpponent": "Changer",
      "challengePlayer": "Défier {{username}}",
      "tableOpen": {
        "title": "{{username}} a déjà une table ouverte",
        "other": "Envoyer un autre défi"
      }
    },
    "status": {
      "playing": "En partie",
      "playingWith": "En partie contre {{username}}",
      "waiting": "En attente",
      "away": "Absent",
      "busy": "Occupé"
    },
    "chooseOpponent": "Choisis qui défier",
    "ratingsBucket": "Classements :",
    "onlinePlayers": "Joueurs en ligne",
    "loadingPlayers": "Chargement des joueurs...",
    "noPlayersOnline": "Personne d’autre n’est en ligne pour l’instant",
    "reloadIn": "Rechargement dans {{seconds}} s",
    "reloadInShort": "{{seconds}} s",
    "rematch": {
      "rematch": "Revanche",
      "accept": "Accepter",
      "decline": "Refuser",
      "sessionScore": "Score",
      "opponentWantsRematch": "L'adversaire veut une revanche !",
      "declined": "Votre adversaire a refusé la revanche",
      "expired": "L'offre de revanche a expiré",
      "invite": {
        "incoming": "Invitation à la revanche",
        "tabBadge": "Revanche !",
        "message": "<b>{{name}}</b> ({{rating}}) veut une revanche · <b>{{timeControl}}</b> · {{variant}}",
        "messageNoRating": "<b>{{name}}</b> veut une revanche · <b>{{timeControl}}</b> · {{variant}}"
      },
      "waitingForOpponent": "En attente de l'adversaire...",
      "newOpponent": "Retour à l'accueil"
    },
    "match": {
      "legFirst": "Aller",
      "legSecond": "Retour",
      "legOf": "Partie {{leg}} sur {{total}}",
      "legShort": "{{leg}}/{{total}}",
      "score": "Match",
      "returnStartsIn": "Le retour commence dans {{seconds}}s",
      "leavingForfeits": "Si tu pars maintenant, tu perds le retour par forfait.",
      "ratingAtMatchEnd": "Le classement est mis à jour à la fin du match.",
      "ready": "Prêt",
      "opponentReady": "Ton adversaire est prêt",
      "waitingOpponent": "En attente de l'adversaire...",
      "complete": "Match terminé",
      "newMatch": "Nouveau match",
      "twoLegsShort": "A/R"
    },
    "connectedCount": "{{count}} Online",
    "viewProfile": "Profil",
    "connessionePersa": {
      "titolo": "Connexion perdue",
      "corpo": "Nous essayons de vous ramener au damier.",
      "riprova": "Réessayer",
      "esci": "Quitter"
    },
    "partitaFinitaMentreEriVia": "La partie s’est terminée pendant votre absence.",
    "sessioneAltrove": {
      "titolo": "Ouvert sur un autre appareil",
      "corpo": "Vous avez ouvert le jeu ailleurs : cette fenêtre ne reçoit plus les coups ni les défis.",
      "usaQui": "Utiliser ici"
    }
  },
  "lobby": {
    "title": "Jouer",
    "quickPlay": "Partie rapide",
    "customGame": "Partie personnalisée",
    "opponent": "Adversaire",
    "opponentOnline": "En ligne (au hasard)",
    "opponentInPerson": "En présentiel",
    "startInPerson": "Commencer la partie",
    "inPersonNote": "Deux joueurs sur le même appareil. Ne compte pas pour le classement.",
    "openTable": "Ouvrir la table",
    "openTables": "Tables en attente",
    "noTablesInVariant": "Aucune table en {{variant}} pour l’instant. Choisis une cadence pour ouvrir la tienne.",
    "noTablesInVariantOrOther": "Aucune table en {{variant}} pour l’instant. Choisis une cadence pour ouvrir la tienne, ou assieds-toi à une table d’une autre variante :",
    "otherVariants": "Autres variantes",
    "sit": "S’asseoir",
    "cancelTable": "Annuler",
    "waitingAtTable": "En attente d’un adversaire",
    "inQueue": "Dans la file",
    "tableExpired": "Ta table a expiré après 10 minutes sans adversaire. Rouvres-en une quand tu veux.",
    "customPosition": "Position personnalisée",
    "errors": {
      "inCompetition": "Quitte d’abord l’arène ou le tournoi.",
      "rateLimited": "Trop de tables. Patiente un instant.",
      "tableGone": "Cette table n’est plus disponible.",
      "hostGone": "Le joueur qui a ouvert cette table n'est plus là.",
      "ownTable": "C’est ta propre table.",
      "invalidSettings": "Ces réglages ne sont pas valides.",
      "startFailed": "La partie n’a pas pu démarrer. Réessaie.",
      "generic": "Une erreur est survenue. Réessaie."
    }
  },
  "spectate": {
    "watch": "Regarder",
    "watchPlayer": "Regarder la partie de {{username}}",
    "watchPair": "Regarder {{a}} contre {{b}}",
    "watching": "Vous regardez",
    "leave": "Quitter",
    "loading": "Chargement de la partie...",
    "turnWhite": "Aux Blancs de jouer",
    "turnBlack": "Aux Noirs de jouer",
    "whiteWins": "Les Blancs gagnent",
    "blackWins": "Les Noirs gagnent",
    "draw": "Nulle",
    "gameOver": "Partie terminée",
    "betweenLegs": "Aller terminé : le retour commence bientôt",
    "unavailable": "Cette partie n'est plus disponible",
    "error": {
      "notPlaying": "Ce joueur n'est plus en partie.",
      "unavailable": "Cette partie n'est plus disponible.",
      "busy": "Vous ne pouvez pas regarder une partie pendant que vous jouez.",
      "self": "C'est votre propre partie — ouvrez-la depuis votre damier."
    },
    "watchers": {
      "empty": "Personne ne regarde pour le moment."
    }
  },
  "auth": {
    "signIn": "Connexion",
    "signUp": "S'inscrire",
    "preferredVariantHint": "Vous pouvez la changer à tout moment",
    "createAccount": "Créer un Compte",
    "noAccount": "Pas encore de compte ?",
    "hasAccount": "Déjà un compte ?",
    "fields": {
      "username": "Nom d'utilisateur",
      "email": "Email",
      "password": "Mot de passe",
      "confirmPassword": "Confirmer le Mot de passe",
      "emailOrUsername": "Email ou Nom d'utilisateur"
    },
    "placeholders": {
      "chooseUsername": "Choisissez un nom d'utilisateur",
      "yourEmail": "votre@email.fr",
      "atLeast8Chars": "Au moins 8 caractères",
      "confirmYourPassword": "Confirmez votre mot de passe",
      "enterEmailOrUsername": "Entrez email ou nom d'utilisateur",
      "yourPassword": "Votre mot de passe"
    },
    "errors": {
      "passwordsNoMatch": "Les mots de passe ne correspondent pas",
      "passwordTooShort": "Le mot de passe doit contenir au moins 8 caractères",
      "usernameTooShort": "Le nom d'utilisateur doit contenir au moins 3 caractères",
      "passwordRequirements": "Le mot de passe doit contenir au moins une majuscule, une minuscule et un chiffre",
      "network": "Pas de connexion Internet. Vérifiez votre connexion et réessayez.",
      "guestLoginFailed": "Impossible de démarrer une session invité. Vérifie ta connexion et réessaie.",
      "guestLoginRateLimited": "Trop de connexions invité depuis ce réseau. Réessaie dans quelques minutes, ou connecte-toi avec ton compte."
    },
    "validation": {
      "usernameChars": "Uniquement lettres, chiffres et underscores",
      "invalidEmail": "Entrez une adresse e-mail valide",
      "min8": "8+ caractères",
      "uppercase": "majuscule",
      "lowercase": "minuscule",
      "number": "chiffre"
    },
    "playAsGuest": "Jouer en tant qu'invité",
    "guestBanner": "Vous jouez en tant qu'invité.",
    "guestBannerCta": "Inscrivez-vous pour sauvegarder votre progression.",
    "guestUpgrade": "Créer un compte",
    "guestRestriction": "Cette fonctionnalité nécessite un compte enregistré",
    "guestCannotTournament": "Inscrivez-vous pour rejoindre les tournois",
    "guestCannotChallenge": "Inscrivez-vous pour défier des joueurs",
    "forgotPassword": "Mot de passe oublié ?",
    "forgotPasswordDesc": "Entrez votre email et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    "sendResetLink": "Envoyer le lien",
    "resetEmailSent": "Vérifiez votre email",
    "checkSpam": "Pas trouvé ? Vérifiez votre dossier spam.",
    "backToLogin": "Retour à la connexion",
    "resetPassword": "Réinitialiser le mot de passe",
    "resetPasswordDesc": "Entrez votre nouveau mot de passe ci-dessous.",
    "newPassword": "Nouveau mot de passe",
    "confirmPassword": "Confirmer le mot de passe",
    "resetSuccess": "Mot de passe mis à jour avec succès. Vous pouvez maintenant vous connecter.",
    "resetExpired": "Ce lien a expiré. Veuillez en demander un nouveau.",
    "resetInvalid": "Lien de réinitialisation invalide ou expiré.",
    "verifyEmail": {
      "title": "Vérifiez votre email",
      "checkInbox": "Nous avons envoyé un lien de vérification à {{email}}. Cliquez sur le lien pour activer votre compte.",
      "spamHint": "Pas trouvé ? Vérifiez votre dossier spam.",
      "pageTitle": "Vérification de l'email",
      "verifying": "Vérification de votre email...",
      "success": "E-mail vérifié. Votre compte est actif.",
      "successAndBack": "E-mail vérifié. Nous vous ramenons au tournoi.",
      "verifyButton": "Vérifier mon email",
      "error": "Échec de la vérification. Veuillez réessayer.",
      "loginBlocked": "Veuillez vérifier votre email avant de vous connecter",
      "resendLink": "Renvoyer l'email de vérification",
      "resendSent": "Email de vérification envoyé !",
      "enterEmailToResend": "Connectez-vous avec votre adresse email pour renvoyer la vérification",
      "wrongAddress": "Mauvaise adresse ?",
      "changeAddress": "Corriger l'adresse",
      "newAddressLabel": "Nouvelle adresse e-mail",
      "passwordLabel": "Le mot de passe que tu viens de choisir",
      "changeSubmit": "Envoyer à la nouvelle adresse",
      "changeSent": "Si le compte existe et attend une vérification, nous avons envoyé le lien à la nouvelle adresse.",
      "changeFailed": "Impossible de changer l'adresse. Réessaie dans quelques minutes."
    }
  },
  "profile": {
    "title": "Profil",
    "notFound": "Profil Non Trouvé",
    "userNotFound": "Utilisateur non trouvé",
    "memberSince": "Membre depuis {{date}}",
    "goBack": "Retour",
    "loadingProfile": "Chargement du profil...",
    "tabs": {
      "overview": "Aperçu",
      "games": "Parties",
      "stats": "Statistiques"
    },
    "variants": {
      "all": "Toutes"
    },
    "stats": {
      "rating": "Classement",
      "games": "Parties",
      "wins": "Victoires",
      "losses": "Défaites",
      "draws": "Nuls",
      "winRate": "Taux de Victoire",
      "winRateShort": "Victoires",
      "winLossBreakdown": "Victoires · Nulles · Défaites",
      "peakRating": "Record",
      "streak": "Série",
      "bestStreak": "Meilleure",
      "avgTime": "Temps Moy.",
      "title": "Statistiques Détaillées",
      "comingSoon": "Bientôt disponible...",
      "loading": "Chargement des statistiques...",
      "noData": "Aucune partie jouée. Jouez quelques parties pour voir vos statistiques!",
      "byTimeControl": "Performance par Cadence",
      "byVariant": "Performance par Variante",
      "byColor": "Performance par Couleur",
      "general": "Général",
      "asWhite": "Avec les Blancs",
      "asBlack": "Avec les Noirs",
      "totalGames": "Total Parties",
      "avgMoves": "Coups Moyens",
      "gamesShort": "parties",
      "mostActive": "Joueurs les plus actifs",
      "mostActiveEmpty": "Aucune partie dans cette variante pour le moment.",
      "viewFullLeaderboard": "Voir le classement complet",
      "ratingEvolution": "Évolution du classement · 30 derniers jours",
      "chartComingSoon": "Historique à venir",
      "peakShort": "Record",
      "barraEsito": "{{win}} % de victoires, {{draw}} % de nulles, {{loss}} % de défaites",
      "percentualeVittorie": "{{rate}} % de victoires",
      "siglaVittorie": "V",
      "siglaPatte": "N",
      "siglaSconfitte": "D"
    },
    "games": {
      "today": "Aujourd'hui",
      "yesterday": "Hier",
      "daysAgo": "il y a {{days}} jours",
      "weeksAgo": "il y a {{weeks}} sem.",
      "moves": "coups",
      "sourceArena": "Arena",
      "sourceTournament": "Tournoi",
      "loading": "Chargement des parties...",
      "noGames": "Aucune partie trouvée",
      "clearFilters": "Effacer les filtres",
      "clearFiltersActive": "Effacer les filtres actifs",
      "loadMore": "Charger plus",
      "showing": "{{count}} parties",
      "clickViewAll": "Cliquez sur \"Tout voir\" pour l'historique",
      "filterResult": "Résultat",
      "filterTimeControl": "Cadence",
      "filterVariant": "Variante",
      "filterOpponent": "Adversaire",
      "filters": {
        "all": "Toutes",
        "wins": "Victoires",
        "draws": "Nuls",
        "losses": "Défaites",
        "allVariants": "Toutes les Variantes",
        "allTimeControls": "Toutes les Cadences",
        "vsMe": "Contre moi"
      }
    },
    "challenge": "Défier",
    "settings": "Paramètres",
    "gameSettings": "Paramètres de jeu",
    "preferredVariant": "Variante préférée",
    "preferredCadence": "Cadence préférée",
    "accountSettings": "Compte",
    "audioHaptics": "Son et Vibration",
    "changePassword": "Changer le mot de passe",
    "changePasswordSub": "Mettez à jour votre mot de passe",
    "currentPassword": "Mot de passe actuel",
    "newPassword": "Nouveau mot de passe",
    "passwordChanged": "Mot de passe modifié avec succès",
    "analyticsLabel": "Cookies analytiques",
    "language": "Langue",
    "country": "Pays",
    "countryNone": "Non défini",
    "logout": "Déconnexion",
    "logoutSub": "Déconnectez-vous de votre compte",
    "exportData": "Exporter mes données",
    "exportDataSub": "Téléchargez un JSON de vos données",
    "deleteAccount": {
      "button": "Supprimer le compte",
      "sub": "Supprimez définitivement votre compte",
      "title": "Supprimer le Compte",
      "warning": "Cette action est permanente et ne peut pas être annulée. Toutes vos données seront supprimées.",
      "confirmPassword": "Entrez votre mot de passe pour confirmer",
      "confirm": "Supprimer définitivement",
      "error": "Impossible de supprimer le compte"
    },
    "graphics": {
      "title": "Graphismes",
      "pieceShape": "Forme des pions",
      "pieceStyle": "Style des pions",
      "kingIcon": "Icône de la dame",
      "pieceColor": "Couleur des pions",
      "pieceColorAutoHint": "Les couleurs des pions changent selon la variante.",
      "pieceMaterial": "Matière des pions",
      "boardColor": "Couleur du damier",
      "boardColorAutoHint": "Les couleurs du damier changent selon la variante.",
      "boardMaterial": "Matière du damier",
      "boardNotation": "Notation du damier",
      "notation": "Notation",
      "shapes": {
        "round": "Rond",
        "donut": "Beignet",
        "square": "Carré",
        "rhombus": "Losange",
        "triangle": "Triangle",
        "star": "Étoile",
        "heart": "Cœur"
      },
      "styles": {
        "3d-stacked-engraved": "3D empilé, gravé",
        "3d-stacked-smooth": "3D empilé, lisse",
        "3d-crown": "3D avec couronne",
        "flat-plain": "Plat, uni",
        "flat-engraved": "Plat, gravé"
      },
      "kingIcons": {
        "crown": "Couronne",
        "ring": "Anneau",
        "star": "Étoile",
        "diamond": "Diamant",
        "none": "Aucune"
      },
      "crownType": "Type de couronne",
      "crownTypes": {
        "classic": "Classique",
        "plain": "Sobre",
        "diadem": "Diadème",
        "lily": "Fleurdelisée",
        "imperial": "Impériale"
      },
      "pieceColors": {
        "auto": "Auto (par variante)",
        "custom": "Personnalisé…",
        "italian": "Italien",
        "international": "International",
        "english": "Anglais",
        "brazilian": "Brésilien",
        "classic": "Classique",
        "white-black": "Blanc/Noir",
        "red-black": "Rouge/Noir",
        "blue-red": "Bleu/Rouge",
        "orange-blue": "Orange/Bleu (daltonisme)",
        "silver-gold": "Argent/Or",
        "coral-teal": "Corail/Turquoise",
        "green-purple": "Vert/Violet",
        "pink-navy": "Rose/Bleu marine"
      },
      "materials": {
        "plastic": "Plastique",
        "marble": "Marbre",
        "glass": "Verre",
        "wood": "Bois"
      },
      "boards": {
        "auto": "Auto (par variante)",
        "custom": "Personnalisé…",
        "wood-classic": "International",
        "italian": "Italien",
        "english": "Anglais",
        "brazilian": "Brésilien",
        "walnut": "Noyer",
        "green-cream": "Vert/Crème",
        "blue-grey": "Bleu/Gris",
        "marble": "Marbre",
        "high-contrast": "Contraste élevé",
        "mahogany": "Acajou",
        "ocean": "Océan",
        "purple-lavender": "Violet/Lavande",
        "rose": "Rose"
      },
      "notations": {
        "none": "Aucune",
        "numeric": "Chiffres",
        "algebraic": "Coordonnées"
      },
      "hue": "Teinte",
      "customPieceLight": "Pions clairs",
      "customPieceDark": "Pions foncés",
      "customBoardLight": "Cases claires",
      "customBoardDark": "Cases foncées",
      "picker": {
        "edit": "Modifier les couleurs",
        "hex": "Hexadécimal",
        "area": "Saturation et luminosité",
        "saturation": "Saturation",
        "brightness": "Luminosité",
        "tooClose": "Ces deux couleurs sont très proches : les pions ou les cases risquent d’être difficiles à distinguer."
      },
      "uiTheme": "Thème de l’application",
      "themes": {
        "light": "Clair",
        "dark": "Sombre"
      }
    },
    "game": {
      "title": "Jeu",
      "moveSound": "Activer le son des coups",
      "lowTimeSound": "Activer le son de temps bas",
      "notificationSound": "Activer les sons de notification",
      "vibration": "Activer la vibration pour les coups"
    },
    "gameplay": {
      "title": "Jeu",
      "showMoveHints": "Afficher les coups possibles",
      "showLastMove": "Surligner le dernier coup",
      "showLastMoveCaptures": "Surligner les prises",
      "premove": "Activer les précoups"
    },
    "avatar": {
      "title": "Choisissez un avatar",
      "choose": "Avatars disponibles",
      "remove": "Aucun avatar",
      "edit": "Changer d'avatar",
      "presets": {
        "crown": "Couronne",
        "star": "Étoile",
        "flame": "Flamme",
        "zap": "Éclair",
        "shield": "Bouclier",
        "rocket": "Fusée",
        "gem": "Gemme",
        "leaf": "Feuille",
        "moon": "Lune",
        "sun": "Soleil",
        "heart": "Cœur",
        "ghost": "Fantôme"
      }
    },
    "viewProfileOf": "Voir le profil de {{username}}",
    "report": {
      "trigger": "Signaler {{username}}",
      "title": "Signaler {{username}}",
      "intro": "Dites-nous ce qui ne va pas dans ce profil. Un modérateur l'examinera.",
      "reasonLabel": "Motif",
      "reasons": {
        "offensive_username": "Nom d'utilisateur offensant",
        "offensive_avatar": "Photo de profil offensante",
        "harassment": "Harcèlement ou menaces",
        "spam": "Spam ou publicité",
        "other": "Autre"
      },
      "noteLabel": "Détails (facultatif)",
      "notePlaceholder": "Tout ce qui peut nous aider à comprendre",
      "privacyHint": "Le signalement est conservé {{days}} jours pour la modération. Le profil est public : nous n'en conservons aucune copie.",
      "submit": "Envoyer le signalement",
      "sending": "Envoi...",
      "done": "Signalement envoyé. Merci.",
      "errors": {
        "duplicate": "Vous avez déjà signalé ce joueur. Un modérateur l'examine.",
        "notFound": "Ce joueur n'est plus disponible.",
        "self": "Vous ne pouvez pas vous signaler vous-même.",
        "registeredOnly": "Il faut un compte enregistré pour signaler depuis ici.",
        "rateLimited": "Trop de signalements. Réessayez plus tard.",
        "generic": "Le signalement n'a pas pu être envoyé. Réessayez."
      }
    }
  },
  "gamesHistory": {
    "title": "Historique des Parties",
    "gamesPlayed": "{{count}} parties jouées",
    "noGames": "Aucune partie. Jouez en ligne pour les voir ici !",
    "signInToView": "Connectez-vous pour voir votre historique.",
    "loadingGames": "Chargement des parties...",
    "loadingGame": "Chargement de la partie...",
    "failedToLoad": "Échec du chargement des parties",
    "moves": "{{count}} coups"
  },
  "replay": {
    "backToGames": "Retour aux Parties",
    "loadFailed": "Impossible d'ouvrir cette partie. Réessaie.",
    "result": {
      "whiteWins": "Les blancs gagnent",
      "blackWins": "Les noirs gagnent",
      "draw": "Match nul"
    },
    "controls": {
      "goToStart": "Aller au début",
      "previousMove": "Coup précédent",
      "nextMove": "Coup suivant",
      "goToEnd": "Aller à la fin",
      "play": "Lecture",
      "pause": "Pause",
      "showMoves": "Afficher les coups",
      "hideMoves": "Masquer les coups",
      "position": "Position dans la partie"
    },
    "downloadPdn": "Télécharger PDN",
    "openInEditor": "Étudier dans l'éditeur",
    "share": "Partager",
    "shareCopied": "Lien copié !",
    "shareTitle": "Partie de dames",
    "shareText": "Regarde cette partie de dames",
    "shareSheet": {
      "pdnTitle": "Télécharger le PDN",
      "withNotes": "Avec mes notes ({{count}})",
      "withoutNotes": "Sans les notes",
      "pdnIntro": "Les notes deviennent des commentaires dans le fichier PDN."
    }
  },
  "review": {
    "save": {
      "save": "Enregistrer la partie",
      "saved": "Enregistrée",
      "title": "Enregistrer la partie",
      "intro": "Choisis un dossier pour retrouver cette partie.",
      "confirm": "Enregistrer",
      "remove": "Retirer des parties enregistrées",
      "error": "Impossible d'enregistrer la partie"
    },
    "folders": {
      "unsorted": "Sans dossier",
      "newLabel": "Nouveau dossier",
      "newPlaceholder": "Nom du dossier",
      "create": "Créer",
      "duplicate": "Un dossier portant ce nom existe déjà",
      "rename": "Renommer",
      "renameFolder": "Renommer « {{name}} »",
      "renameLabel": "Nouveau nom du dossier",
      "renameError": "Impossible de renommer le dossier",
      "delete": "Supprimer",
      "deleteFolder": "Supprimer « {{name}} »",
      "deleteConfirm": "Supprimer ?",
      "deleteHint": "Les parties ne sont pas supprimées : elles retournent dans « Sans dossier ».",
      "deleteError": "Impossible de supprimer le dossier",
      "filterLabel": "Dossier",
      "savedOnly": "Enregistrées uniquement",
      "gameCount_one": "{{count}} partie",
      "gameCount_other": "{{count}} parties"
    },
    "notes": {
      "add": "Ajouter une note",
      "atStart": "Note sur la position initiale",
      "atMove": "Note au coup {{ply}}",
      "placeholder": "Écris une note sur cette position…",
      "save": "Enregistrer la note",
      "delete": "Supprimer la note",
      "jumpTo": "Aller à la note du coup {{ply}}",
      "error": "Impossible d'enregistrer la note",
      "hasNote": "Cette position a une note"
    }
  },
  "leaderboard": {
    "title": "Classement",
    "subtitle": "Top 100 Joueurs",
    "loading": "Chargement du classement...",
    "empty": "Aucun joueur avec des parties terminées.",
    "allTime": "Rating",
    "mostGames": "Plus actifs",
    "bullet": "Bullet",
    "blitz": "Blitz",
    "rapid": "Rapid",
    "classical": "Classique",
    "columns": {
      "rank": "#",
      "player": "Joueur",
      "rating": "Classement",
      "class": "Classe",
      "games": "Parties",
      "days": "Jours",
      "record": "Record"
    },
    "period": {
      "label": "Jours",
      "days": "{{days}} jours",
      "all": "Toujours"
    },
    "emptyPeriod": "Aucune partie dans cette variante ces {{days}} derniers jours.",
    "emptyStreak": "Personne n’a de streak en cours pour le moment.",
    "classes": {
      "novice": "Débutant",
      "intermediate": "Intermédiaire",
      "advanced": "Avancé",
      "expert": "Expert",
      "master": "Maître",
      "grandmaster": "Grand maître",
      "legend": "Légende"
    }
  },
  "tournament": {
    "title": "Tournois",
    "subtitle": "Testez vos compétences dans des tournois compétitifs",
    "list": {
      "heroTitle": "Les tournois",
      "arenasLink": "Voir toutes les arènes",
      "archive_one": "Le dernier tournoi terminé.",
      "archive_other": "Les {{count}} derniers tournois terminés."
    },
    "createTournament": "Créer un tournoi",
    "formats": {
      "arena": "Arena",
      "italoSwiss": "Toutes rondes/Suisse (selon les inscrits)",
      "swiss": "Système suisse",
      "roundRobin": "Round Robin (toutes rondes)",
      "arenaShort": "Arena",
      "italoSwissShort": "Toutes rondes/Suisse",
      "swissShort": "Suisse",
      "roundRobinShort": "Toutes rondes"
    },
    "filters": {
      "all": "Tous",
      "live": "En Direct",
      "upcoming": "À Venir",
      "variant": "Variante",
      "status": "Statut",
      "international": "International",
      "italian": "Italien",
      "english": "Anglais",
      "brazilian": "Brésilien",
      "comingSoon": "Bientôt",
      "owner": "Tournois",
      "mine": "Les miens"
    },
    "sections": {
      "live": "En Cours",
      "upcoming": "À Venir",
      "finished": "Terminés"
    },
    "status": {
      "live": "EN DIRECT",
      "upcoming": "À VENIR",
      "finished": "TERMINÉ",
      "scheduled": "PROGRAMMÉ",
      "cancelled": "ANNULÉ"
    },
    "card": {
      "rated": "Classé",
      "registered": "Inscrit",
      "gamesPlayed_one": "{{count}} partie jouée",
      "gamesPlayed_other": "{{count}} parties jouées",
      "players_one": "{{count}} joueur",
      "players_other": "{{count}} joueurs",
      "starts": "Début {{time}}",
      "startsAt": "Commence à {{time}}",
      "startsAtTomorrow": "Commence demain à {{time}}",
      "startsAtDate": "Commence le {{date}} à {{time}}",
      "startsInCountdown": "Commence dans {{time}}",
      "startingNow": "Commence maintenant !",
      "privateHint": "Tournoi privé : il faut une invitation ou le mot de passe",
      "publicHint": "Tournoi public : ouvert à tous",
      "private": "Privé",
      "seats": "Places",
      "yourPlace": "toi {{rank}}e",
      "gettoneAlle": "Commence à",
      "gettoneDomani": "Demain à",
      "gettoneData": "{{date}} à",
      "gettoneTra": "Commence dans",
      "gettoneMin": "min"
    },
    "games": {
      "allGames": "Toutes les parties",
      "myGames": "Mes parties",
      "noGames": "Aucune partie jouée",
      "moves": "coups",
      "analyze": "Analyser",
      "round": "Ronde {{n}}"
    },
    "participants": {
      "sortByScore": "Par score",
      "sortByRating": "Par classement",
      "sortByName": "A-Z",
      "status": {
        "playing": "En jeu",
        "online": "En ligne",
        "offline": "Hors ligne"
      }
    },
    "matchFound": {
      "title": "Adversaire trouvé !",
      "opponent": "Adversaire",
      "playAsWhite": "Vous jouez les blancs",
      "playAsBlack": "Vous jouez les noirs",
      "startingIn": "Début dans...",
      "startNow": "Commencer"
    },
    "postGame": {
      "currentRank": "Classement actuel",
      "continue": "Continuer"
    },
    "empty": {
      "live": "Aucun tournoi en direct actuellement.",
      "upcoming": "Aucun tournoi programmé.",
      "all": "Aucun tournoi disponible.",
      "mine": "Vous n'avez aucun tournoi. Créez-en un, ou rejoignez-en un avec une invitation.",
      "finished": "Aucun tournoi terminé pour le moment.",
      "goLive": "Voir ceux en cours",
      "goUpcoming": "Voir les prochains",
      "goFinished": "Voir l'archive"
    },
    "loading": "Chargement des tournois...",
    "notFound": "Tournoi non trouvé",
    "detail": {
      "timeControl": "Cadence",
      "duration": "Durée",
      "players": "Joueurs",
      "games": "Parties",
      "startsIn": "Début {{time}}",
      "joinTournament": "Rejoindre le Tournoi",
      "register": "S'inscrire",
      "unregister": "Se désinscrire",
      "leaveTournament": "Quitter le Tournoi",
      "yourStats": "Vos Statistiques",
      "points": "Points",
      "rank": "Rang",
      "askPassword": "Mot de passe du tournoi",
      "share": "Partager l'invitation",
      "shareStandings": "Partager le classement",
      "shareCopied": "Lien copié",
      "cancelTournament": "Annuler le tournoi",
      "cancelConfirm": "Le tournoi disparaît et les inscrits sont prévenus. C'est irréversible.",
      "cancelYes": "Oui, annuler",
      "cancelNo": "Non, le garder",
      "createdBy": "Créé par {{username}}",
      "regenerate": "Nouvelles clés",
      "regenerateHint": "L’ancien lien cesse de fonctionner. Choisis un nouveau mot de passe et renvoie l’invitation.",
      "regenerateNewPassword": "Nouveau mot de passe",
      "regenerateConfirm": "Créer de nouvelles clés",
      "regenerateCancel": "Laisser tomber",
      "regenerateDone": "Nouvelles clés créées : l’ancien lien ne vaut plus",
      "ratingFloor": "Classement minimum",
      "aiutoAssenza": "Que se passe-t-il si je ne joue pas ?",
      "aiutoApertura": "Pourquoi certaines parties commencent-elles avec des coups déjà joués ?",
      "formatoTitolo": "Comment le format est décidé",
      "formatoOraGirone": "Avec les inscrits actuels ({{n}}), ce serait un toutes rondes.",
      "formatoOraSvizzero": "Avec les inscrits actuels ({{n}}), ce serait un système suisse.",
      "formatoOraPochi": "Il faut au moins {{min}} inscrits pour commencer : il y en a {{n}}.",
      "formatoPrevisto": "Prévu",
      "seSvizzero": "Si c'est un suisse",
      "seGirone": "Si c'est un toutes rondes",
      "punteggio": "Système de points"
    },
    "scoring": {
      "title": "Système de Points Arena",
      "win": "Victoire : +{{points}}",
      "draw": "Nul : +{{points}}"
    },
    "standings": {
      "title": "Classement",
      "liveStandings": "Classement en Direct",
      "empty": "Aucun joueur encore. Soyez le premier !",
      "morePlayers_one": "+ {{count}} autre joueur",
      "morePlayers_other": "+ {{count}} autres joueurs",
      "columns": {
        "rank": "#",
        "player": "Joueur",
        "points": "Points",
        "status": "Statut",
        "winsDrawsLosses": "V/N/D",
        "winsDrawsLossesByes": "V/N/D/E",
        "byes": "Exempt"
      },
      "status": {
        "playing": "En jeu",
        "ready": "Prêt",
        "paused": "En pause",
        "left": "Parti",
        "offline": "Hors ligne",
        "assente": "Absent",
        "haFinito": "En attente",
        "riposa": "Exempt",
        "disconnesso": "Déconnecté"
      },
      "tied": "Ex æquo",
      "tiebreakHelp": "Comment les égalités sont-elles départagées ?",
      "sdSigla": "CD",
      "sdSpiega": "Devant {{nomi}} aux confrontations directes entre ex aequo",
      "scoreSheet": {
        "label": "Parcours : {{esiti}}",
        "outcome": {
          "win": "gagnée",
          "winPlus": "gagnée, valant plus",
          "draw": "nulle",
          "loss": "perdue",
          "bye": "exempt"
        },
        "clipped": "les plus anciennes sortent à gauche",
        "hint": "Toutes les parties, la plus récente à droite",
        "hintRiposoSvizzero": "le carré est un tour sans adversaire, et vaut une victoire",
        "hintRiposoGirone": "le carré est un tour sans adversaire, et ne rapporte rien"
      }
    },
    "lobby": {
      "leaveTournament": "Quitter le Tournoi",
      "waitingForOpponent": "En attente d'un adversaire...",
      "pts": "pts",
      "rank": "rang",
      "yourPosition": "Votre Position"
    },
    "timer": {
      "remaining": "Restant",
      "finished": "Terminé",
      "started": "Commencé",
      "daysHours": "{{days}}j {{hours}}h"
    },
    "tabs": {
      "standings": "Classement",
      "games": "Parties",
      "details": "Détails",
      "participants": "Participants",
      "gamesPlaceholder": "Les parties récentes apparaîtront ici"
    },
    "rules": {
      "title": "Règles de Score"
    },
    "create": {
      "title": "Créer un tournoi",
      "infoAbout": "À propos de {{campo}}",
      "nameLabel": "Nom du Tournoi *",
      "namePlaceholder": "ex. Arena Blitz du Dimanche",
      "nameRequired": "Le nom du tournoi est requis",
      "aperturaUnicaHint": "Une seule ouverture pour toutes les rondes et toutes les parties du tournoi — utile pour un tournoi à thème sur une seule ouverture",
      "aperturaUnicaScelta": "n° {{id}}",
      "aperturaUnicaScegli": "Choisis l’ouverture",
      "aperturaUnicaMancante": "Choisis une ouverture pour continuer",
      "aperturaUnicaAmichevole": "Cette ouverture est trop déséquilibrée pour qu’une seule partie la compense : le tournoi est amical. Avec aller-retour, il reste classé.",
      "nameLength": "Le nom doit contenir 3-100 caractères",
      "descriptionLabel": "Description (optionnel)",
      "descriptionPlaceholder": "Décrivez votre tournoi...",
      "timeControlLabel": "Cadence",
      "durationLabel": "Durée",
      "startsAtLabel": "Heure de début",
      "startsAtRange": "De 5 minutes à 14 jours à partir de maintenant.",
      "startsAtInvalid": "Choisis une heure entre 5 minutes et 14 jours à partir de maintenant.",
      "visibilityLabel": "Visibilité",
      "visibilityPublic": "Public",
      "visibilityPrivate": "Privé",
      "passwordLabel": "Mot de passe du tournoi",
      "passwordHint": "Tu pourras la relire plus tard pour la partager. N'utilise pas le mot de passe de ton compte.",
      "passwordRequired": "Un tournoi privé a besoin d'un mot de passe",
      "estimate": "{{players}} joueurs, {{rounds}} rondes → environ {{duration}}, fin vers {{end}}",
      "estimateRange": "{{players}} joueurs, de {{roundsMin}} à {{roundsMax}} rondes → environ {{duration}}, fin avant {{end}}",
      "durationOptions": {
        "30min": "30 min",
        "1hour": "1 heure",
        "1.5hours": "1h30",
        "2hours": "2 heures",
        "3hours": "3 heures"
      },
      "minRatingLabel": "Classement Min",
      "maxRatingLabel": "Classement Max",
      "ratedLabel": "Classé",
      "ratingFloorLabel": "Classement minimum",
      "ratingFloorHint": "En dessous de ce classement, l'inscription est refusée. Il est mesuré sur votre classement pour la variante et la cadence de ce tournoi : qui n'a jamais joué cette combinaison compte comme débutant. Uniquement pour les tournois classés.",
      "ratingFloorNone": "Aucun",
      "variantLabel": "Variante",
      "variantInternational": "International (10×10)",
      "variantItalian": "Italien (8×8)",
      "variantEnglish": "Anglais (8×8)",
      "formatLabel": "Format",
      "maxPlayersLabel": "Joueurs max",
      "thresholdLabel": "Suisse dès",
      "thresholdHint": "À partir de {{n}} inscrits, on joue au système suisse ; en dessous, un toutes rondes. Les rondes sont fixées au coup d'envoi, selon les présents. À trois ou quatre inscrits, le toutes rondes se joue aussi au retour : toujours trois rondes, mais de deux parties chacune, car une partie par adversaire serait trop peu.",
      "extraRoundLabel": "Rondes supplémentaires (suisse)",
      "extraRoundHint": "Une ou deux rondes de plus que ce que donne la table, tant que le plateau le supporte. Cela ne change rien en toutes rondes : là tout le monde rencontre tout le monde, et une ronde de plus serait une revanche pour tous.",
      "extraRoundsNone": "Aucune",
      "extraRoundsOne": "+1 ronde",
      "extraRoundsTwo": "+2 rondes",
      "tooLongWarningSeats": "Plus d'une journée de jeu : enlevez des places ou raccourcissez la cadence.",
      "minPlayersLabel": "Joueurs min",
      "minPlayersHint": "En dessous de ce nombre, le tournoi s'annule tout seul à l'heure du début. Plus vous l'augmentez, plus c'est probable.",
      "seatsWarning": "Au-delà de ce nombre, personne d'autre ne pourra entrer, et vous ne pourrez plus le changer.",
      "submitButton": "Créer le Tournoi",
      "submitting": "Création...",
      "failedToCreate": "Échec de la création du tournoi",
      "arenaHint": "Une arène n'a pas de rondes : on vous apparie en continu jusqu'à la fin du temps.",
      "arenaDurationHint": "Combien de temps l'arène reste ouverte. Huit heures au maximum.",
      "arenaSummary": "Arène de {{duration}}, fin vers {{end}}",
      "twoLegLabel": "Aller-retour",
      "twoLegHint": "Chaque appariement se joue deux fois de suite, couleurs inversées.",
      "twoLegItaloHint": "Les deux mêmes joueurs se rencontrent deux fois dans la même ronde, couleurs inversées et même ouverture : la ronde dure deux fois plus longtemps, le nombre de rondes ne double pas. À trois ou quatre inscrits, le retour se joue toujours, quoi que dise ce bouton.",
      "boostLabel": "Boost",
      "boostHint": "Qui joue peut parier : il renonce à la moitié du temps de base et à l'incrément, et une victoire vaut le double. Il se prend avant son propre premier coup. Désactivé, personne ne l'utilise dans cette arène.",
      "roundsHelp": "Combien de rondes se jouent ?"
    },
    "signInToJoin": "Connectez-vous pour rejoindre les tournois",
    "roundRobin": {
      "scontroDiretto": "Confrontation directe entre les joueurs à égalité (au classement «CD»)",
      "tiebreakerInfo": "Départage : victoires, confrontation directe, Sonneborn-Berger, variation de classement Elo dans le tournoi"
    },
    "swiss": {
      "roundOf": "Ronde {{current}} sur {{total}}",
      "scoringWin": "Victoire : +{{points}}",
      "scoringDraw": "Nulle : +{{points}}",
      "scoringLoss": "Défaite : {{points}}",
      "buchholz": "BH",
      "sb": "SB",
      "variazione": "Δ",
      "variazioneTitolo": "Variation de classement Elo dans le tournoi",
      "criterioVittorie": "Nombre de victoires",
      "tiebreakersTitle": "Départages",
      "buchholzCut1": "Buchholz (Cut 1)",
      "sonnebornBerger": "Sonneborn-Berger (SB)",
      "cannotJoinInProgress": "Ce tournoi Swiss est déjà en cours. Vous ne pouvez pas rejoindre en cours de tournoi.",
      "returnLegPending": "La manche retour va commencer : mêmes adversaires, couleurs inversées.",
      "waitingBetweenRounds": "En attente de la prochaine ronde...",
      "waitingFinalResults": "En attente des résultats finaux...",
      "waitingForRoundEnd": "En attente de la fin de la ronde...",
      "tiebreakerInfo": "Départage : Buchholz Cut 1, Sonneborn-Berger, victoires, variation de classement Elo dans le tournoi",
      "byeRoundPunti": "Vous vous reposez cette ronde : +{{punti}} points, déjà au classement.",
      "byeRoundNessunPunto": "Vous vous reposez cette ronde : en toutes rondes, l'exemption ne rapporte aucun point.",
      "byeProssimoTurno": "La ronde suivante commence d'elle-même quand les autres parties sont finies.",
      "byeUltimoTurno": "Les résultats finaux arrivent quand les autres parties sont finies.",
      "returnLegTra": "La manche retour commence dans {{secondi}} s : mêmes adversaires, couleurs inversées.",
      "partiteConcluse": "Parties terminées : {{completate}} sur {{totali}}",
      "turnoParteDaSolo": "La ronde suivante démarre d'elle-même",
      "nonCiSiRitira": "Une fois le tournoi commencé, on ne peut pas se retirer : si vous ne jouez pas, vous restez apparié et perdez vos parties au temps."
    },
    "errors": {
      "authRequired": "Connectez-vous pour participer à un tournoi.",
      "guestNotAllowed": "Les tournois sont réservés aux comptes enregistrés.",
      "notAllowed": "Opération non autorisée.",
      "notFound": "Ce tournoi n’existe plus.",
      "userNotFound": "Joueur introuvable.",
      "invalidInput": "Requête invalide.",
      "rateLimited": "Trop de requêtes : patientez un instant.",
      "joinFailed": "Inscription échouée. Réessayez.",
      "arenaPiena": "Cette arène est complète : il n'y a plus de places.",
      "arenaChiusa": "Cette arène n'accepte plus d'inscriptions.",
      "giaIscritto": "Tu es déjà inscrit à cette arène.",
      "arenaAnnullata": "Cette arène a été annulée : à l'heure du début, les inscrits n'étaient pas assez nombreux.",
      "notJoinable": "Les inscriptions à ce tournoi sont closes.",
      "roundsStarted": "La ronde a déjà commencé.",
      "ratingTooLow": "Votre classement est inférieur au minimum exigé par ce tournoi.",
      "wrongFormat": "Format de tournoi non concordant.",
      "privateTournament": "Ce tournoi est privé : il faut le lien ou le mot de passe.",
      "wrongPassword": "Mot de passe incorrect.",
      "tooManyAttempts": "Trop de tentatives. Réessaie dans un quart d'heure.",
      "tournamentFull": "Le tournoi est complet.",
      "alreadyHasLive": "Vous avez déjà 3 compétitions en cours : vous pourrez en ouvrir une autre dès que l’une d’elles sera terminée.",
      "nameTaken": "Il y a déjà un tournoi de ce nom à cette heure-là.",
      "startTooSoon": "Trop tôt : laisse au moins cinq minutes pour inviter quelqu'un.",
      "startTooFar": "Trop loin : deux semaines maximum à partir de maintenant.",
      "notOrganizer": "Seul l’organisateur peut le faire.",
      "alreadyStarted": "Le tournoi a déjà commencé.",
      "tooLong": "Le tournoi durerait plus d'une journée : enlevez des rondes ou raccourcissez la cadence.",
      "cancelledByOrganizer": "L'organisateur a annulé ce tournoi.",
      "cancelledNoPlayers": "Le tournoi a été annulé : pas assez de joueurs inscrits.",
      "serverError": "Erreur du serveur. Réessayez plus tard.",
      "offline": "Vous semblez hors ligne : vérifiez la connexion.",
      "timeout": "Le serveur n’a pas répondu. Réessayez.",
      "loadFailed": "Impossible de charger les tournois.",
      "notYourTurn": "Ce n’est pas votre tour.",
      "drawOfferFailed": "Impossible de proposer la nulle.",
      "unknown": "Quelque chose s’est mal passé. Réessayez.",
      "moveRejected": "Le serveur a refusé votre coup : le plateau est revenu comme avant.",
      "partitaSvanita": "La partie n'est plus sur le serveur : il a probablement redémarré. Te voilà de retour dans le salon du tournoi.",
      "notInTournament": "Vous n'êtes pas inscrit à ce tournoi.",
      "tournamentFullWayOut": "Voir les autres tournois et arènes",
      "notPrivate": "Ce tournoi est public : il n’a pas de clés à refaire",
      "samePassword": "Le nouveau mot de passe est identique à l’ancien",
      "tournamentCancelled": "Le tournoi a été annulé.",
      "inviteLinkExpired": "Ce lien d’invitation ne fonctionne plus : rejoins avec le mot de passe."
    },
    "ended": {
      "title": "Tournoi terminé",
      "winner": "Vainqueur",
      "noWinner": "Aucun vainqueur : aucune partie n'a été jouée.",
      "tiedWith": "Premier ex æquo avec {{players}}"
    },
    "share": {
      "title": "Tournoi de dames",
      "text": "Vous êtes invité au tournoi {{nome}} sur draughtsgame.com",
      "standingsTitle": "Classement final — {{nome}}"
    }
  },
  "chat": {
    "title": "Chat",
    "openChat": "Ouvrir le chat",
    "closeChat": "Fermer le chat",
    "empty": "Aucun message. Dites bonjour !",
    "placeholder": "Tapez un message...",
    "unavailable": "Chat indisponible",
    "opponentLeft": "Votre adversaire a quitté la partie.",
    "rateLimited": "Vous écrivez trop vite : attendez quelques secondes.",
    "closingIn": "Le chat se ferme dans {{seconds}}s",
    "closed": "Le chat de cette partie est fermé.",
    "guestHint": "Les invités peuvent envoyer des réactions rapides. Inscrivez-vous pour le chat complet.",
    "report": {
      "trigger": "Signaler",
      "title": "Signaler {{username}}",
      "intro": "Dites-nous ce qui s'est passé. Un modérateur examinera le chat de cette partie.",
      "quoteLabel": "Dernier message de {{username}}",
      "reasonLabel": "Motif",
      "reasons": {
        "insult": "Insultes ou langage offensant",
        "harassment": "Harcèlement ou menaces",
        "hate_speech": "Discours haineux ou discrimination",
        "spam": "Spam ou publicité",
        "other": "Autre chose"
      },
      "noteLabel": "Détails (facultatif)",
      "notePlaceholder": "Tout ce qui peut nous aider à comprendre",
      "privacyHint": "Le chat de cette partie (jusqu'à 100 messages, des deux joueurs) est enregistré pour la modération et conservé {{days}} jours.",
      "submit": "Envoyer le signalement",
      "sending": "Envoi...",
      "done": "Signalement envoyé. Merci.",
      "muted": "Vous avez signalé ce joueur. Ses messages sont masqués.",
      "errors": {
        "gone": "Cette partie est terminée et son chat n'est plus vérifiable. Écrivez-nous depuis la page d'aide.",
        "duplicate": "Vous avez déjà signalé ce joueur pour cette partie.",
        "notReportable": "Cet adversaire ne peut pas être signalé.",
        "notInGame": "Vous ne jouez pas cette partie.",
        "rateLimited": "Trop de signalements. Réessayez plus tard.",
        "generic": "Impossible d'envoyer le signalement. Réessayez."
      }
    },
    "quickPhrases": "Phrases rapides",
    "presets": {
      "hello": "Salut !",
      "goodLuck": "Bon jeu !",
      "haveFun": "Amuse-toi bien !",
      "goodGame": "Belle partie !",
      "untilNext": "À la prochaine !",
      "thanks": "Merci !"
    }
  },
  "landing": {
    "nav": {
      "title": "Dama Online",
      "play": "Jouer",
      "tournaments": "Tournois",
      "learn": "Apprendre",
      "community": "Communauté",
      "login": "Connexion"
    },
    "hero": {
      "badge": "L'Expérience Ultime des Dames",
      "title": "Devenez un Maître des Dames",
      "subtitle": "Jouez contre des joueurs du monde entier, participez aux tournois et améliorez vos compétences avec nos outils d'entraînement avancés.",
      "playFree": "Jouer Maintenant",
      "watchDemo": "Voir la Démo"
    },
    "stats": {
      "players": "Joueurs Actifs",
      "games": "Parties Jouées",
      "variants": "Variantes de Jeu",
      "tournaments": "Tournois Quotidiens"
    },
    "features": {
      "title": "Pourquoi Choisir Dama Online ?",
      "subtitle": "Tout ce dont vous avez besoin pour devenir un maître des dames",
      "variants": {
        "title": "Plusieurs Variantes",
        "description": "Jouez aux dames Italiennes, Internationales, Anglaises et Brésiliennes - tout sur une seule plateforme."
      },
      "matchmaking": {
        "title": "Matchmaking Intelligent",
        "description": "Notre système de classement Glicko-2 garantit des parties équitables et compétitives."
      },
      "tournaments": {
        "title": "Tournois Arena",
        "description": "Affrontez des joueurs du monde entier dans des tournois quotidiens."
      },
      "ai": {
        "title": "Entraînement IA",
        "description": "Entraînez-vous contre notre IA avancée avec plusieurs niveaux de difficulté."
      },
      "analysis": {
        "title": "Analyse de Partie",
        "description": "Revoyez vos parties et apprenez de vos erreurs avec une analyse détaillée."
      },
      "community": {
        "title": "Communauté Active",
        "description": "Rejoignez des clubs, discutez avec d'autres joueurs et faites-vous des amis partageant votre passion."
      }
    },
    "variants": {
      "title": "Jouez Votre Variante Préférée",
      "subtitle": "Nous supportons les variantes de dames les plus populaires du monde entier",
      "pieces": "pions",
      "italian": "Dames Italiennes",
      "international": "Dames Internationales",
      "english": "Dames Anglaises",
      "brazilian": "Dames Brésiliennes"
    },
    "testimonials": {
      "1": {
        "name": "Marco B.",
        "role": "Joueur de Tournoi",
        "text": "La meilleure plateforme de dames que j'ai utilisée. Le matchmaking est équitable et les tournois sont passionnants !"
      },
      "2": {
        "name": "Elena V.",
        "role": "Joueuse Occasionnelle",
        "text": "J'adore la facilité avec laquelle on trouve une partie. L'interface est belle et intuitive."
      },
      "3": {
        "name": "Hans K.",
        "role": "Champion de Club",
        "text": "Enfin une plateforme qui prend les dames internationales au sérieux. Hautement recommandée !"
      },
      "title": "Ce Que Disent les Joueurs"
    },
    "cta": {
      "title": "Prêt à Jouer ?",
      "subtitle": "Rejoignez des milliers de joueurs et commencez votre aventure aux dames aujourd'hui.",
      "button": "Commencer à Jouer"
    },
    "footer": {
      "tagline": "La plateforme de dames en ligne de référence",
      "game": "Jeu",
      "playNow": "Jouer Maintenant",
      "tournaments": "Tournois",
      "leaderboard": "Classement",
      "puzzles": "Puzzles",
      "learn": "Apprendre",
      "tutorial": "Tutoriel",
      "strategies": "Stratégies",
      "rules": "Règles",
      "videos": "Vidéos",
      "community": "Communauté",
      "forum": "Forum",
      "clubs": "Clubs",
      "blog": "Blog",
      "discord": "Discord",
      "rights": "Tous droits réservés."
    }
  },
  "arena": {
    "title": "Arène",
    "subtitle": "Jeu continu rapide",
    "ending": "Fin en cours...",
    "status": {
      "live": "EN DIRECT",
      "upcoming": "À VENIR",
      "finished": "TERMINÉE"
    },
    "card": {
      "yourPlace": "toi {{rank}}e"
    },
    "actions": {
      "join": "Rejoindre l'Arène",
      "leave": "Quitter l'Arène",
      "play": "Jouer",
      "pause": "Pause",
      "resume": "Reprendre le Jeu",
      "boost": "Boost",
      "backToGame": "Retour à la partie",
      "retry": "Réessayer"
    },
    "errors": {
      "authRequired": "Tu dois être connecté pour participer à l'arène.",
      "guestNotAllowed": "Les invités ne peuvent pas rejoindre une arène. Crée un compte pour conserver tes parties.",
      "notAllowed": "Ce compte ne peut pas rejoindre une arène.",
      "arenaNotFound": "Cette arène n'existe plus.",
      "userNotFound": "Nous ne trouvons pas ton compte. Reconnecte-toi.",
      "invalidInput": "La demande n'était pas valide. Recharge la page et réessaie.",
      "rateLimited": "Trop de tentatives. Attends quelques secondes et réessaie.",
      "ratingTooLow": "Votre classement est inférieur au minimum exigé par cette arène.",
      "joinFailed": "Impossible de t'inscrire à l'arène. Réessaie.",
      "arenaPiena": "Cette arène est complète : il n'y a plus de places.",
      "arenaChiusa": "Cette arène n'accepte plus d'inscriptions.",
      "giaIscritto": "Tu es déjà inscrit à cette arène.",
      "arenaScaduta": "Le temps de cette arène est écoulé : on attend seulement la fin des dernières parties.",
      "arenaAnnullata": "Cette arène a été annulée.",
      "arenaAnnullataPochiIscritti": "Cette arène a été annulée : à l'heure du début, les inscrits n'étaient pas assez nombreux.",
      "arenaAnnullataDaOrganizzatore": "La personne qui a ouvert cette arène l'a annulée.",
      "notOrganizer": "Seule la personne qui a ouvert l’arène peut le faire.",
      "alreadyStarted": "L’arène a déjà commencé.",
      "giaInUnArena": "Vous êtes déjà dans une arène en cours : quittez-la pour jouer dans celle-ci",
      "leaveFailed": "Impossible de te retirer de l'arène. Réessaie.",
      "notInArena": "Tu n'es pas inscrit à cette arène.",
      "notInGame": "Tu ne joues pas cette partie.",
      "gameNotFound": "Cette partie n'existe plus.",
      "tooLate": "Trop tard : le boost ne se change qu'avant ton premier coup.",
      "boostDisabled": "Dans cette arène, le boost est désactivé.",
      "alreadyBoosted": "Le boost est déjà actif dans cette partie.",
      "notBoosted": "Le boost n'est pas actif dans cette partie.",
      "boostFailed": "Impossible d'activer le boost. Réessaie.",
      "unboostFailed": "Impossible de désactiver le boost. Réessaie.",
      "serverError": "Un problème est survenu de notre côté. Réessaie.",
      "offline": "Pas de connexion au serveur.",
      "timeout": "Le serveur n'a pas répondu. Réessaie.",
      "unknown": "Un problème est survenu. Réessaie.",
      "notYourTurn": "Ce n'est pas votre tour.",
      "drawOfferFailed": "Nous n'avons pas pu envoyer votre proposition de nulle. Réessayez.",
      "moveRejected": "Le serveur a refusé votre coup : le damier est revenu comme avant."
    },
    "standings": {
      "search": "Chercher un joueur",
      "searchEmpty": "Aucun joueur de ce nom.",
      "sheetHint": "Toutes les parties, la plus récente à droite · or = bonus",
      "loadMore": "Afficher plus",
      "sheet": "Parties",
      "toClimb_one": "{{count}} point pour monter",
      "toClimb_other": "{{count}} points pour monter",
      "lead_one": "{{count}} point d'avance",
      "lead_other": "{{count}} points d'avance",
      "boostOn": "boost activé",
      "searchScope": "La recherche ne regarde que les lignes déjà chargées : chargez les autres pour chercher parmi tous.",
      "justPlayedHint": "Le signe ↺ : vous venez de jouer contre cette personne — à côté figure le temps restant avant qu'elle puisse revenir.",
      "justPlayedIn": "Déjà affronté : de nouveau disponible dans {{time}}"
    },
    "info": {
      "details": "Détails",
      "scoring": "Système de Points",
      "loss": "Défaite : {{points}}",
      "boostTitle": "Boost ⚡",
      "boostTimeCost": "Vous retire l'incrément et divise par deux le temps de base",
      "boostExtraPoint": "Double vos points de victoire en cas de gain",
      "boostBeforeFirst": "Activable et désactivable jusqu’à votre premier coup"
    },
    "matchFound": {
      "title": "Adversaire Trouvé",
      "opponent": "Adversaire",
      "playAsWhite": "Vous jouez les Blancs",
      "playAsBlack": "Vous jouez les Noirs",
      "startingIn": "Début dans",
      "startNow": "Commencer"
    },
    "gameEnd": {
      "win": "Victoire",
      "loss": "Défaite",
      "draw": "Nulle",
      "pointsEarned": "Points gagnés",
      "basePoints": "Points de base",
      "boostBonus": "Bonus boost",
      "total": "Total",
      "pointsVoided": "Partie non comptabilisée : aucun point attribué aux deux joueurs",
      "rank": "Position",
      "totalPoints": "Points",
      "paused": "Tu es en pause : reprends quand tu veux.",
      "arenaFinished": "Arène terminée",
      "arenaDraining": "Temps écoulé : l'arène ferme dès la fin des dernières parties.",
      "analyze": "Analyser",
      "pause": "En pause",
      "playNext": "Continuer",
      "backToArena": "Retour à l’arène",
      "resumeFailed": "Nous n’avons pas pu vous remettre dans la file : vérifiez votre connexion et réessayez.",
      "returnLegIn_one": "Retour dans {{count}} seconde…",
      "returnLegIn_other": "Retour dans {{count}} secondes…"
    },
    "game": {
      "boost": "Boost",
      "boostRemove": "Retirer",
      "boostRetry": "Réessayer"
    },
    "confirmBoost": {
      "title": "Activer le boost ?",
      "halve": "Ton temps de base passe de {{prima}} à {{dopo}} et tu perds l’incrément de {{incremento}}s.",
      "halveOnly": "Ton temps de base passe de {{prima}} à {{dopo}}.",
      "reward": "Si tu gagnes, les points comptent double. Tu peux le retirer jusqu’à ton premier coup.",
      "confirm": "Activer"
    },
    "results": {
      "arenaFinished": "Arène Terminée",
      "yourPosition": "Votre position",
      "outOf_one": "sur {{count}} joueur",
      "outOf_other": "sur {{count}} joueurs",
      "yourStats": "Vos Statistiques",
      "totalPoints": "Points totaux",
      "gamesPlayed": "Parties jouées",
      "games": "parties",
      "wins": "Victoires",
      "draws": "Nulles",
      "losses": "Défaites",
      "winRate": "Taux de victoire",
      "boostUsed": "Boosts utilisés",
      "share": "Partager",
      "nextArena": "Arène Suivante",
      "unavailable": "Nous n’avons pas les résultats de cette arène.",
      "unavailableSub": "Revenez à la liste et rouvrez-la depuis l’onglet « Terminées »."
    },
    "tabs": {
      "rules": "Règles"
    },
    "signInToJoin": "Connectez-vous pour rejoindre les arènes",
    "positionCta": "Rejoins et rivalise pour grimper au classement !",
    "band": {
      "searchingTitle": "Je cherche un adversaire",
      "searchingSub": "Dès que je trouve un appariement, je t’emmène en partie.",
      "drainingTitle": "Le temps est écoulé",
      "drainingSub": "Plus aucun appariement : le classement final sort avec la dernière partie.",
      "pausedTitle": "Tu es en pause",
      "pausedSub": "Personne ne t’est apparié tant que tu ne reprends pas.",
      "pausedAwaySub": "Je t’ai mis en pause car l’appli était en arrière-plan. Reprends quand tu veux.",
      "pausedOfflineSub": "Je t'ai mis en pause parce que tu étais hors ligne au démarrage de l'arène.",
      "pausedOtherArenaSub": "Vous jouez dans l’autre arène. Quand vous aurez fini là-bas, appuyez sur Reprendre pour revenir dans la file ici.",
      "playingTitle": "Tu es en partie",
      "playingSub": "La partie est encore ouverte : retournes-y.",
      "playingSubVs": "Contre {{opponent}} · avec les {{color}}.",
      "waitingTitle": "Tu es inscrit",
      "waitingSub": "L’arène n’a pas encore commencé.",
      "joinTitle": "Tu n’es pas inscrit",
      "joinSub": "Inscris-toi et je t’apparie avec ceux qui attendent."
    },
    "timebar": {
      "endsIn": "Finit dans"
    },
    "games": {
      "mine": "Les miennes",
      "deletedPlayer": "Joueur supprimé",
      "loadFailed": "Nous n’avons pas pu charger les parties."
    },
    "a11y": {
      "scoreUpdate": "Maintenant {{points}} points, place {{rank}}"
    },
    "spotlight": {
      "eyebrow": "Arène",
      "daysHours": "{{days}}j {{hours}}h",
      "startsIn": "Commence dans",
      "yourResult": "Tu as fini {{rank}}e",
      "review": "Voir comment ça s'est passé"
    },
    "twoLeg": "Aller-retour",
    "noBoost": "Sans boost",
    "share": {
      "title": "Arène de dames",
      "text": "Vous êtes invité à l’arène {{nome}} sur draughtsgame.com"
    },
    "detail": {
      "askPassword": "Mot de passe de l'arène",
      "share": "Partager l'invitation",
      "shareCopied": "Lien copié",
      "cancelArena": "Annuler l'arène",
      "cancelConfirm": "L'arène disparaît et tous les inscrits sont prévenus. C'est sans retour."
    }
  },
  "specialEvent": {
    "eyebrow": "Événement spécial",
    "badge": "Spécial",
    "organizedBy": "Organisé par Draughts Game"
  },
  "legal": {
    "termsTitle": "CGU",
    "privacyTitle": "Confidentialité",
    "acceptTerms": "J'accepte les <terms>Conditions d'Utilisation</terms> et la <privacy>Politique de Confidentialité</privacy>",
    "acceptTermsOnly": "J'accepte les <terms>Conditions d'Utilisation</terms>",
    "acceptPrivacyOnly": "J'accepte la <privacy>Politique de Confidentialité</privacy>",
    "ageConfirm": "Je confirme avoir au moins 16 ans",
    "acceptRequired": "Vous devez accepter les Conditions d'Utilisation",
    "acceptTermsRequired": "Cochez la case pour accepter les Conditions d'Utilisation",
    "acceptPrivacyRequired": "Cochez la case pour accepter la Politique de Confidentialité",
    "ageRequired": "Cochez la case pour confirmer votre âge",
    "lastUpdated": "Dernière mise à jour",
    "subtitle": "Vos droits et nos engagements",
    "missingConsents_one": "Encore {{count}} case à cocher ci-dessus",
    "missingConsents_other": "Encore {{count}} cases à cocher ci-dessus"
  },
  "cookies": {
    "message": "Nous utilisons des cookies essentiels au fonctionnement du site. Si vous acceptez, nous utilisons aussi des outils de mesure — Umami, pour voir comment le site est utilisé, et Sentry, pour repérer les erreurs. Vous pouvez refuser : le site fonctionne tout autant.",
    "acceptAll": "Tout accepter",
    "rejectAnalytics": "Essentiels uniquement"
  },
  "puzzle": {
    "toPlayAndWin": "jouent et gagnent",
    "black": "Noirs",
    "white": "Blancs",
    "dashboard": "Tableau de bord",
    "hint": "Indice",
    "hintTip": "Un indice ne coûte que le classement : ce puzzle devient non classé, vous ne gagnez ni ne perdez de points. Il compte toujours comme résolu et conserve votre Streak.",
    "solution": "Solution",
    "solutionTip": "Révéler la solution compte comme une tentative échouée : vous perdez des points de classement, mais la journée compte quand même pour votre Streak.",
    "continueVsAI": "Continuer contre l'IA",
    "playAgain": "Rejouer",
    "back": "Précédent",
    "forward": "Suivant",
    "puzzleRating": "Classement du puzzle",
    "ratingChange": "Classement",
    "newRating": "maintenant",
    "yourRating": "Votre classement",
    "solutionMoves": "Solution",
    "moves": "coups",
    "motifs": "Motifs",
    "motifsRevealed": "révélés",
    "motifsHidden": "révélés après résolution",
    "result": {
      "solvedEyebrow": "Résolu",
      "failedEyebrow": "Solution",
      "nice": "Bien",
      "solving": "joué.",
      "theLine": "Voici la",
      "line": "solution."
    },
    "title": "Puzzles",
    "loading": "Chargement du puzzle…",
    "yourTurn": "Trouvez le meilleur coup !",
    "correct": "Correct !",
    "incorrect": "Pas tout à fait",
    "solved": "Puzzle résolu !",
    "failed": "Puzzle échoué",
    "giveUp": "Abandonner",
    "nextPuzzle": "Puzzle suivant",
    "backToHome": "Retour à l'accueil",
    "rating": "Rating",
    "daily": "Puzzle du jour",
    "practice": "Entraînement",
    "share": "Partager",
    "solve": "Résoudre",
    "demo": {
      "badge": "Puzzle de démonstration",
      "solvedTitle": "Bravo, résolu !",
      "trainTitle": "Envie de vous entraîner chaque jour ?",
      "registerPitch": "Créez un compte gratuit : un nouveau puzzle chaque jour, différent pour chaque variante.",
      "registerCta": "Créer un compte gratuit"
    },
    "retry": "Réessayer",
    "shareTitle": "Puzzle du jour",
    "shareText": "J'ai résolu le puzzle du jour — et toi ?",
    "shareCopied": "Lien copié !",
    "unavailable": {
      "title": "Ce puzzle n’est pas disponible",
      "link": "Impossible d’ouvrir le puzzle du jour. Il n’y en a peut-être pas pour cette variante, ou la connexion a été perdue.",
      "session": "Impossible de démarrer ce puzzle. Vérifiez votre connexion et réessayez.",
      "home": "Aller à l’accueil"
    },
    "invite": {
      "title": "Le problème du jour t'attend",
      "body": "Un ami t'a partagé le problème du jour. Les problèmes quotidiens sont réservés aux joueurs inscrits — crée un compte gratuit, ou connecte-toi, pour débloquer le damier.",
      "locked": "Aperçu verrouillé",
      "tryDemo": "En attendant, essaie le problème de démo",
      "moves_one": "{{count}} coup",
      "moves_other": "{{count}} coups"
    },
    "guest": {
      "locked": "Les daily puzzles sont réservés aux joueurs inscrits. Connecte-toi ou crée un compte gratuit pour y jouer."
    },
    "networkError": "Problème de réseau : le coup n’a pas été enregistré. Réessayez."
  },
  "dashboard": {
    "hero": {
      "welcome": "Bon retour",
      "settings": "Paramètres",
      "ctaPlayNow": "Jouer maintenant",
      "ctaVsComputer": "Affronter l'IA",
      "moreVariants": "Autres variantes ({{count}})",
      "logoutConfirmTitle": "Se déconnecter ?",
      "logoutConfirmBody": "Vous serez déconnecté de votre compte sur cet appareil.",
      "ctaDailyPuzzle": "Problèmes du jour",
      "themeDark": "Passer au thème sombre",
      "themeLight": "Passer au thème clair",
      "ratingDeltaUp": "{{points}} points gagnés sur les 7 derniers jours",
      "ratingDeltaDown": "{{points}} points perdus sur les 7 derniers jours"
    },
    "notif": {
      "challengedYou": "<b>{{name}}</b> ({{rating}}) t'a défié en <b>{{timeControl}}</b> · {{variant}}",
      "challengedYouNoRating": "<b>{{name}}</b> t'a défié en <b>{{timeControl}}</b> · {{variant}}",
      "accept": "Accepter",
      "decline": "Refuser"
    },
    "streak": {
      "daysInRow_one": "{{count}} jour d'affilée",
      "daysInRow_other": "{{count}} jours d'affilée",
      "unitLabel_one": "jour d'affilée",
      "unitLabel_other": "jours d'affilée",
      "record": "Record à battre : <b>{{count}} jours</b>",
      "recordTying": "Record égalé : <b>{{count}} jours</b>",
      "empty": "Commence aujourd'hui",
      "solvePuzzle": "Résous un problème",
      "doneToday": "C'est fait pour aujourd'hui 🔥",
      "keepHint": "Joue ou résous un problème pour garder ton streak.",
      "last7DaysLabel": "Activité des 7 derniers jours"
    },
    "dailyGoal": {
      "title": "Objectif du jour",
      "label": "Parties",
      "remaining_one": "<b>Encore une</b> pour terminer l'objectif",
      "remaining_other": "<b>Encore {{count}}</b> pour terminer l'objectif",
      "done": "Objectif atteint",
      "targetLabel": "Parties par jour",
      "editGoal": "Modifier l'objectif"
    },
    "activity": {
      "title": "Activité",
      "last3Months": "3 derniers mois",
      "centerGames": "parties",
      "statsGames_one": "{{count}} partie",
      "statsGames_other": "{{count}} parties",
      "statsActiveDays_one": "{{count}} jour actif",
      "statsActiveDays_other": "{{count}} jours actifs",
      "statsPerDay": "{{value}} parties/jour",
      "empty": "Tes parties apparaîtront ici",
      "statsTotalTime": "{{value}} au total",
      "tooltipToday": "Aujourd'hui",
      "tooltipYesterday": "Hier",
      "legendBucket0": "0",
      "legendBucket1": "1-2",
      "legendBucket2": "3-5",
      "legendBucket3": "6-9",
      "legendBucket4": "10+",
      "duration": {
        "zero": "0 min",
        "minutes_one": "{{count}} min",
        "minutes_other": "{{count}} min",
        "hours_one": "{{count}}h",
        "hours_other": "{{count}}h",
        "hoursMinutes": "{{hours}}h {{minutes}}m"
      },
      "dayMon": "Lun",
      "dayThu": "Jeu",
      "daySat": "Sam",
      "dayTue": "Mar",
      "dayWed": "Mer",
      "dayFri": "Ven",
      "daySun": "Dim"
    },
    "recentGames": {
      "title": "Parties récentes",
      "viewAll": "Voir tout dans le profil →",
      "replay": "Revoir",
      "empty": "Aucune partie pour l'instant"
    },
    "upcomingTournaments": {
      "title": "Tournois actifs",
      "viewAll": "Tout voir →",
      "viewAllAria": "Voir tous les tournois",
      "empty": "Aucun tournoi programmé"
    },
    "liveEvent": {
      "emptyTitle": "Tournois & Arènes",
      "empty": "Aucun événement en cours",
      "nextAt": "Le prochain Daily démarre à {{time}}",
      "minutesLeft_one": "Se termine dans {{count}} minute",
      "minutesLeft_other": "Se termine dans {{count}} minutes",
      "participants_one": "{{count}} joueur",
      "participants_other": "{{count}} joueurs"
    },
    "puzzle": {
      "titleWhiteToMove": "Les blancs jouent\net gagnent",
      "titleBlackToMove": "Les noirs jouent\net gagnent",
      "meta": "Trouve la meilleure séquence",
      "cta": "Résoudre →",
      "viewAll": "Tous →",
      "tag": {
        "tactic": "Tactique"
      },
      "solvedNext": "Résolu ✓ · Reviens demain pour le prochain",
      "tryInternational": "Essayez un puzzle International →",
      "overlayTitle": "Problèmes du jour"
    },
    "avvisoDati": {
      "offline": "Vous semblez hors ligne — vos données ne se sont pas chargées.",
      "server": "Impossible de charger vos données.",
      "inCorso": "Nouvel essai…",
      "ricarica": "Recharger"
    },
    "installCard": {
      "eyebrow": "App",
      "title": "Installer Draughts Game",
      "benefit": "Ajoutez-la à votre écran d'accueil : elle s'ouvre en plein écran, démarre plus vite et se range avec vos autres applis.",
      "howTo": "Comment faire ?",
      "choose": "Choisissez votre appareil :",
      "os": {
        "android": "Android",
        "ios": "iPhone ou iPad",
        "desktop": "Ordinateur"
      }
    }
  },
  "pwa": {
    "openInAppText": "Vous êtes dans le navigateur de WhatsApp. Ouvrez ce lien en dehors pour profiter de toute l'application.",
    "openInAppCta": "Ouvrir dans l'application",
    "openInBrowserText": "Vous êtes dans le navigateur de WhatsApp. Ouvrez ce lien dans Safari pour profiter de toute l'application.",
    "iosHint": "Touchez ••• en bas à droite, puis « Ouvrir dans Safari ».",
    "installText": "Installez Draughts Game pour jouer depuis votre écran d'accueil.",
    "installCta": "Installer l'application",
    "copyLink": "Copier le lien",
    "linkCopied": "Lien copié !",
    "dismiss": "Fermer"
  },
  "seo": {
    "breadcrumbHome": "Accueil",
    "landing": {
      "title": "Draughts Game — jouer aux dames en ligne gratuitement",
      "description": "Jouez aux dames en ligne gratuitement : internationales, italiennes, turques, frisonnes et 20 autres variantes. Multijoueur en temps réel, parties classées, tournois, adversaires IA et un problème par jour."
    },
    "faq": {
      "title": "Questions fréquentes — jouer aux dames en ligne",
      "description": "Réponses sur les comptes, le classement, les tournois, l’installation de l’application et les parties en ligne, avec un canal direct pour les signalements."
    },
    "terms": {
      "title": "Conditions d’utilisation — Draughts Game",
      "description": "Les conditions qui encadrent l’usage de Draughts Game : comptes, loyauté du jeu, classement, contenus et règles acceptées de part et d’autre."
    },
    "privacy": {
      "title": "Politique de confidentialité — Draughts Game",
      "description": "Quelles données Draughts Game collecte, pourquoi, combien de temps elles sont conservées et quels droits vous avez dessus au titre du RGPD."
    }
  }
}
